import React, { useState, useEffect, useCallback } from "react";
import { Auth, Storage } from "aws-amplify";
import { v4 as uuid } from "uuid";
import { useNavigate, useLocation } from "react-router-dom";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { jwtDecode } from "jwt-decode";
import { Modal, Button } from "react-bootstrap";
import { useLoading } from "../../context/LoadingContext";
import config from "../../aws-exports";
import { getParameterFromManager } from "../../services/Utils";
import "../../styles/general.css";
import "../../styles/amtpl.css";
import SidebarCommon from "../../pages/Requirement/components/layout/AMTPLSidebar";
import Header from "../../pages/Requirement/components/layout/Header";

// Utility function to format date from "2025-09-30 00:00:00" to "09/30/25"
const formatDateToMMDDYY = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString.replace(' ', 'T'));
  if (isNaN(date)) return '';
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yy = String(date.getFullYear()).slice(-2);
  return `${mm}/${dd}/${yy}`;
};

const AMTPL = () => {
  const [queryDescription, setQueryDescription] = useState("");

  const [activeTab, setActiveTab] = useState("offerInformation");
  const [activeOffersTab, setActiveOffersTab] = useState("vmOffers");
  const [activeEntitiesTab, setActiveEntitiesTab] = useState("buyer");
  const [activeUser, setActiveUser] = useState("");

  const [sellerItemDetails, setSellerItemDetails] = useState([]);
  const [selectedSellerItemDetail, setSelectedSellerItemDetail] =
    useState(null);
  const [currentSellerItemDetailPage, setCurrentSellerItemDetailPage] =
    useState(1);
  const [totalSellerItemDetailPages, setTotalSellerItemDetailPages] =
    useState(1);

  // Removed sellerItemDetailQueries state as it's no longer needed with new tab structure
  const [queryPage, setQueryPage] = useState(1);

  const [selectedCountry, setSelectedCountry] = useState("");

  const [activeEntitiesBuyerTab, setActiveEntitiesBuyerTab] =
    useState("clientDetails");
  const [activeEntitiesGlobalPartnerTab, setActiveEntitiesGlobalPartnerTab] =
    useState("gpDetails");
  const [activeEntitiesSellerTab, setActiveEntitiesSellerTab] =
    useState("supplierDetails");
  const [names, setNames] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [locations, setLocations] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);

  const [amtplBuyers, setAMTPLBuyers] = useState([]);
  const [currentAMTPLBuyerPage, setCurrentAMTPLBuyerPage] = useState(1);
  const [totalAMTPLBuyerPages, setTotalAMTPLBuyerPages] = useState(1);
  const [selectedAMTPLBuyer, setSelectedAMTPLBuyer] = useState(null);

  const [amtplGlobalPartners, setAMTPLGlobalPartners] = useState([]);
  const [currentAMTPLGlobalPartnerPage, setCurrentAMTPLGlobalPartnerPage] =
    useState(1);
  const [totalAMTPLGlobalPartnerPages, setTotalAMTPLGlobalPartnerPages] =
    useState(1);
  const [selectedAMTPLGlobalPartner, setSelectedAMTPLGlobalPartner] =
    useState(null);

  const [amtplSellers, setAMTPLSellers] = useState([]);
  const [currentAMTPLSellerPage, setCurrentAMTPLSellerPage] = useState(1);
  const [totalAMTPLSellerPages, setTotalAMTPLSellerPages] = useState(1);
  const [selectedAMTPLSeller, setSelectedAMTPLSeller] = useState(null);

  const [countries, setCountries] = useState([]);
  const [currentGPOfferPage, setCurrentGPOfferPage] = useState(1);
  const [
    currentGPOfferSellerAggregatePage,
    setCurrentGPOfferSellerAggregatePage,
  ] = useState(1);
  const [totalGPOfferPages, setTotalGPOfferPages] = useState(1);
  const [
    totalGPOfferSellerAggregatePages,
    setTotalGPOfferSellerAggregatePages,
  ] = useState(1);
  const [queryTotalPages, setQueryTotalPages] = useState(1);
  const [selectedGPOffer, setSelectedGPOffer] = useState(null);
  const [
    selectedGPOfferSellerAggregateItem,
    setSelectedGPOfferSellerAggregateItem,
  ] = useState(null);

  const [selectedQuery, setSelectedQuery] = useState(null);
  const [filterTerms, setFilterTerms] = useState({
    product: "",
    grade: "",
    state: "",
  });
  const [entitiesFilterTerms, setEntitiesFilterTerms] = useState({
    name: "",
    company: "",
    location: "",
    zipcode: "",
    globalPartner: "",
  });

  // New state variables for View & Modify Offers search filters
  const [vmOffersFilters, setVmOffersFilters] = useState({
    product: "",
    grade: "",
    createdDate: "",
    quantity: "",
    destinationCountry: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [showRaiseQueryModal, setShowRaiseQueryModal] = useState(false);

  const [products, setProducts] = useState([]);
  const [states, setStates] = useState([]);
  const [globalPartners, setGlobalPartners] = useState([]);
  const [buyers, setBuyers] = useState([]);
  const [selectedGlobalPartner, setSelectedGlobalPartner] = useState("");
  const [selectedBuyer, setSelectedBuyer] = useState("");
  const [gpOffers, setGPOffers] = useState([]);
  const [gpOfferSellerAggregateItems, setGPOfferSellerAggregateItems] =
    useState([]);
  const [minOfferQuantityMT, setMinOfferQuantityMT] = useState(0);

  const [selectedProductName, setSelectedProductName] = useState("");
  const [selectedGrade, setSelectedGrade] = useState("");
  // Removed selectedState as it's no longer needed with new tab structure
  const location = useLocation();
  const initialFilter = location.state?.selectedFilter || "products";
  const [selectedOption, setSelectedOption] = useState(initialFilter);
  const [file, setFile] = useState(null);

  const [sellersQuantity, setSellersQuantity] = useState(0);
  const [sellersPrice, setSellersPrice] = useState(0);
  const [sellersPriceForQuantity, setSellersPriceForQuantity] = useState(0);

  const [INRToUsd, setINRToUSD] = useState(0.012);

  let selectedOriginCountry = "India";

  const sellerTypes = [
    "Farmer Producer Company",
    "Trader/ Stockist",
    "AgroPreneur",
    "Large Farmer",
  ];
  const navigate = useNavigate();
  const pageSize = 5;
  const queryPageSize = 5;
  const { setLoading } = useLoading();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  function formatData(data) {
    return data?.toLocaleString();
  }

  function generateErrorMessages(users) {
    // Filter out unsuccessful user attempts
    const failedUsers = users.filter((user) => !user.success);
    // Group by error message
    const errorGroups = failedUsers.reduce((acc, user) => {
      // If the error group doesn't exist, create it
      if (!acc[user.error]) {
        acc[user.error] = [];
      }
      acc[user.error].push(user.email);
      return acc;
    }, {});
    // Create messages for each error group
    const messages = Object.entries(errorGroups).map(([error, emails]) => {
      return ` The following users failed due to error ${error}: ${emails.join(
        ", "
      )}.`;
    });
    // Join all messages or provide a default message
    return messages.length > 0 ? messages.join(" ") : "No failed users.";
  }

  const handleUpload = async () => {
    setLoading(true);
    console.log("Uploading", file.name);
    let uploadFile = `system/usercreate/${uuid()}-${file.name}`;
    await Storage.put(uploadFile, file);
    setFile(null);
    document.getElementById("fileInput").value = "";
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `backendops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "addusers",
            option: activeEntitiesTab,
            inputFile: uploadFile,
            access_token: token,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        console.log("uploading users: ", result);
        if (result === true) {
          setShowModalMsg("Uploading users successful");
        } else {
          setShowModalMsg(generateErrorMessages(result));
        }
        setShowModal(true);
      } else {
        console.error("Error uploading users: ", result);
      }
    } catch (error) {
      console.error("Error uploading users", error);
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  const getBackendName = () => {
    const backend = config.aws_user_files_s3_bucket.split("-");
    return backend[backend.length - 1];
  };

  const fetchGPOffers = async (customParams = {}) => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });

      const body = {
        target: "listGPOfferAdminDetails",
        access_token: user.signInUserSession.idToken.jwtToken,
        rowStart: (currentGPOfferPage - 1) * pageSize,
        pageSize: pageSize,
        userOrder: "CreatedAt DESC, OfferSequenceID DESC",
        ...customParams,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setGPOffers(result.items);
        setTotalGPOfferPages(Math.ceil(result.total / pageSize));
      } else {
        console.error("Error fetching gpOffers: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchGPOfferSellerAggregates = async (GPOfferID) => {
    let gpOfferSellerAggregates;
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });

      const body = {
        target: "listGPOfferSellerAggregateDetails",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms: {
          GPOfferID: GPOfferID,
        },
        rowStart: (currentGPOfferSellerAggregatePage - 1) * pageSize,
        pageSize: pageSize,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setGPOfferSellerAggregateItems(result.items);
        gpOfferSellerAggregates = result.items;
        setTotalGPOfferSellerAggregatePages(Math.ceil(result.total / pageSize));
      } else {
        console.error("Error fetching gpOffers: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
    return gpOfferSellerAggregates;
  };

  const fetchCountries = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDropDownOptions",
            filterTerms: {
              Type: "Country",
            },
            access_token: token,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setCountries(result.items);
      } else {
        console.error("Error fetching Payment Options: ", result);
      }
    } catch (error) {
      console.error("Error fetching Payment Options", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAMTPLUsersSearch = async (option, suboption, searchval) => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDynamicDropDownOptions",
            userTable: "AMTPLUsers",
            option: option,
            suboption: suboption,
            searchval: searchval,
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        if (option === "globalpartner") {
          setGlobalPartners(result.items.map((option) => option.result));
        } else if (option === "buyer") {
          setBuyers(result.items.map((option) => option.result));
        }
      } else {
        console.error(`Error fetching ${option} : ${JSON.stringify(result)}`);
      }
    } catch (error) {
      console.error(`Error fetching ${option} : ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
    }
  };

  const fetchSearchParams = async (option, suboption) => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDynamicDropDownOptions",
            userTable: "AMTPLUsers",
            option: option,
            suboption: suboption,
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        if (suboption === "names") {
          setNames(result.items.map((option) => option.result));
        } else if (suboption === "companies") {
          setCompanies(result.items.map((option) => option.result));
        } else if (suboption === "locations") {
          setLocations(result.items.map((option) => option.result));
        } else if (suboption === "zipcodes") {
          setZipcodes(result.items.map((option) => option.result));
        }
      } else {
        console.error("Error fetching products: ", result);
      }
    } catch (error) {
      console.error("Error fetching products", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listProducts",
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setProducts(result.items);
      } else {
        console.error("Error fetching products: ", result);
      }
    } catch (error) {
      console.error("Error fetching products", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStates = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDynamicDropDownOptions",
            option: "selleritemstates",
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setStates(result.items.map((option) => option.result));
      } else {
        console.error(`Error fetching $States : ${JSON.stringify(result)}`);
      }
    } catch (error) {
      console.error(`Error fetching States: ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
    }
  };

  const handleProductChange = (event) => {
    let productName = event.target.value;
    setSelectedProductName(productName);
    let product = products.find(
      (product) => product.ProductName === productName
    );
    setSelectedGrade(product.Grade);
  };

  const handleCountryChange = (event) => {
    setSelectedCountry(event.target.value);
  };

  const handleGlobalPartnerChange = (event) => {
    let globalPartner = event.target.value;
    setSelectedGlobalPartner(globalPartner);
    fetchAMTPLUsersSearch("buyer", "gpemailid", event.target.value);
  };

  const handleBuyerChange = (event) => {
    setSelectedBuyer(event.target.value);
  };

  const fetchSellerItemDetails = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });

      const body = {
        target: "listSellerItemDetailsAdm",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms: {
          ...filterTerms,
          approved: "No",
        },
        rowStart: (currentSellerItemDetailPage - 1) * pageSize,
        pageSize: pageSize,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setSellerItemDetails(result.items);
        setTotalSellerItemDetailPages(Math.ceil(result.total / pageSize));
        if (result.items.length > 0) {
          setSelectedSellerItemDetail(result.items[0]);
          setSelectedProductName(result.items[0].ProductName);
          setSelectedGrade(result.items[0].Grade);
          // setSelectedState(result.items[0].State); // Removed as selectedState is no longer used
        }
      } else {
        console.error("Error fetching sellerItemDetails: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAMTPLUsers = async (option) => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });

      const body = {
        target: "listAMTPLUsersAdm",
        option: option,
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms: entitiesFilterTerms,
        pageSize: pageSize,
      };
      if (option === "buyer") {
        body.rowStart = (currentAMTPLBuyerPage - 1) * pageSize;
      } else if (option === "globalpartner") {
        body.rowStart = (currentAMTPLGlobalPartnerPage - 1) * pageSize;
      } else if (option === "seller") {
        body.rowStart = (currentAMTPLSellerPage - 1) * pageSize;
      }

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        if (option === "buyer") {
          setAMTPLBuyers(result.items);
          setTotalAMTPLBuyerPages(Math.ceil(result.total / pageSize));
        } else if (option === "globalpartner") {
          setAMTPLGlobalPartners(result.items);
          setTotalAMTPLGlobalPartnerPages(Math.ceil(result.total / pageSize));
        } else if (option === "seller") {
          setAMTPLSellers(result.items);
          setTotalAMTPLSellerPages(Math.ceil(result.total / pageSize));
        }

        if (result.items.length > 0) {
        }
      } else {
        console.error("Error fetching sellerItemDetails: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSellerItemDetailQueries = async () => {
    if (!selectedSellerItemDetail) {
      console.error("No client selected");
      return;
    }
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "listAmtplQueries",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms: { SellerItemID: selectedSellerItemDetail?.SellerItemID },
        rowStart: (queryPage - 1) * queryPageSize,
        pageSize: queryPageSize,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        // setSellerItemDetailQueries(result.items); // Removed as queries tab is no longer used
        setQueryTotalPages(Math.ceil(result.total / queryPageSize));
        if (result.items.length > 0) {
          setSelectedQuery(result.items[0]);
        }
      } else {
        console.error("Error fetching queries: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateQuery = async () => {
    if (!queryDescription) {
      console.error("Query Description is required");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "updateAmtplQuery",
        access_token: user.signInUserSession.idToken.jwtToken,
        updateAmtplQueryInput: {
          QueryID: selectedQuery?.QueryID,
          QueryReply: queryDescription,
        },
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log("Query creation successful", result);
        setShowModalMsg("Query creation successful");
        setShowModal(true);
        // Fetch the updated queries
        fetchSellerItemDetailQueries();
      } else {
        console.error("Error creating query: ", result);
        setShowModalMsg("Error creating query");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
      setShowModalMsg("Error creating query");
      setShowModal(true);
    } finally {
      setLoading(false);
      setShowRaiseQueryModal(false); // Close the modal after handling the query creation
      setQueryDescription(""); // Clear the query description
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        // Check if the user is a member of the AMTPL_ADMINS group
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut(); // Sign out the user
          navigate("/");
        } else {
          setActiveUser(user.attributes.email); // Set the active user email
        }
        let inrToUsdVal = await getParameterFromManager("INR_TO_USD");
        inrToUsdVal = parseFloat(inrToUsdVal);
        setINRToUSD(inrToUsdVal);
      } catch (error) {
        await Auth.signOut(); // Sign out the user
        navigate("/");
      }
    };
    checkUser();
    fetchSellerItemDetails();
    if (activeTab === "selleritemdetailqueries") {
      fetchSellerItemDetailQueries();
    }
    if (selectedOption === "entities") {
      reloadEntityData();
    }
    if (selectedOption === "offers" && activeOffersTab === "vmOffers") {
      fetchGPOffers();
      fetchCountries(); // Add countries fetch for vmOffers tab
    }
    if (selectedOption === "offers" && activeOffersTab === "goAutomatic") {
      fetchCountries();
      fetchAMTPLUsersSearch("globalpartner");
    }
  }, [
    navigate,
    selectedOption,
    queryPage,
    setLoading,
    filterTerms,
    activeEntitiesTab,
    activeOffersTab,
    currentSellerItemDetailPage,
    currentAMTPLBuyerPage,
    currentAMTPLGlobalPartnerPage,
    currentAMTPLSellerPage,
  ]);

  async function reloadEntityData() {
    if (activeEntitiesTab === "buyer") {
      fetchAMTPLUsers("buyer");
      fetchAMTPLUsersSearch("globalpartner");
      fetchSearchParams("buyer", "names");
      fetchSearchParams("buyer", "companies");
      fetchSearchParams("buyer", "locations");
      fetchSearchParams("buyer", "zipcodes");
      setSelectedAMTPLBuyer(null);
    } else if (activeEntitiesTab === "globalpartner") {
      fetchAMTPLUsers("globalpartner");
      fetchSearchParams("globalpartner", "names");
      fetchSearchParams("globalpartner", "companies");
      fetchSearchParams("globalpartner", "locations");
      fetchSearchParams("globalpartner", "zipcodes");
      setSelectedAMTPLGlobalPartner(null);
    } else if (activeEntitiesTab === "seller") {
      fetchAMTPLUsers("seller");
      fetchSearchParams("seller", "names");
      fetchSearchParams("seller", "companies");
      fetchSearchParams("seller", "locations");
      fetchSearchParams("seller", "zipcodes");
      setSelectedAMTPLSeller(null);
    }
  }

  useEffect(() => {
    if (activeTab === "selleritemdetailqueries") {
      fetchSellerItemDetailQueries();
    }
  }, [selectedSellerItemDetail]);

  useEffect(() => {
    fetchProducts();
    fetchStates();
  }, []);

  const handleGradeChange = (event) => {
    setSelectedGrade(event.target.value);
  };

  const handleMinOfferQuantityMTChange = (event) => {
    setMinOfferQuantityMT(event.target.value);
  };

  const handleSignOut = async () => {
    setLoading(true);
    try {
      await Auth.signOut();
      navigate("/");
    } catch (error) {
      console.error("Error signing out: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTabClick = (tab) => {
    if (tab === "selleritemdetailqueries") {
      fetchSellerItemDetailQueries();
    }
    setActiveTab(tab);
  };

  const handleEntitiesTabClick = (tab) => {
    setActiveEntitiesTab(tab);
  };

  const handleEntitiesBuyerTabClick = (tab) => {
    setActiveEntitiesBuyerTab(tab);
  };

  const handleEntitiesGlobalPartnerTabClick = (tab) => {
    setActiveEntitiesGlobalPartnerTab(tab);
  };

  const handleEntitiesSellerTabClick = (tab) => {
    setActiveEntitiesSellerTab(tab);
  };

  const handleOffersTabClick = (tab) => {
    setActiveOffersTab(tab);
  };

  const handleSellerItemDetailPageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalSellerItemDetailPages) {
      setCurrentSellerItemDetailPage(newPage);
    }
  };

  const handleGPOfferPageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalGPOfferPages) {
      setCurrentGPOfferPage(newPage);

      if (hasActiveVMOffersFilters()) {
        // Use the reusable function to build search parameters with preserved filters
        const searchParams = buildVMOffersSearchParams(
          (newPage - 1) * pageSize
        );

        console.log("Paginating with preserved filters:", searchParams);
        fetchGPOffers(searchParams);
      } else {
        // No active filters, fetch regular data
        fetchGPOffers();
      }
    }
  };

  const handleGPOfferSellerAggregatePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalGPOfferSellerAggregatePages) {
      setCurrentGPOfferSellerAggregatePage(newPage);
    }
  };

  const handleAMTPLBuyerPageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalAMTPLBuyerPages) {
      setCurrentAMTPLBuyerPage(newPage);
    }
  };

  const handleAMTPLGlobalPartnerPageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalAMTPLGlobalPartnerPages) {
      setCurrentAMTPLGlobalPartnerPage(newPage);
    }
  };

  const handleAMTPLSellerPageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalAMTPLSellerPages) {
      setCurrentAMTPLSellerPage(newPage);
    }
  };

  const handleQueryPageChange = (newPage) => {
    if (newPage > 0 && newPage <= queryTotalPages) {
      setQueryPage(newPage);
    }
  };

  const handleGPOfferRowClick = async (gpOffer) => {
    setSelectedGPOffer(gpOffer);
    if (gpOffer.OfferType === "Individual") {
      setSellersQuantity(gpOffer.Quantity);
      setSellersPrice(gpOffer.Price);
      setSellersPriceForQuantity(gpOffer.Quantity * gpOffer.Price);
    } else {
      let gpOfferSellerAggregates = await fetchGPOfferSellerAggregates(
        gpOffer.GPOfferID
      );
      let totalQuantity = 0;
      let totalPrice = 0;
      let totalQuantityPrice = 0;
      gpOfferSellerAggregates.forEach((item) => {
        totalQuantity += item.Quantity;
        totalPrice += item.Price;
        totalQuantityPrice += item.Quantity * item.Price;
      });
      setSellersQuantity(totalQuantity);
      setSellersPrice(totalPrice);
      setSellersPriceForQuantity(totalQuantityPrice);
    }
  };

  const handleGPOfferSellerAggregateItemRowClick = (
    gpOfferSellerAggregateItem
  ) => {
    setSelectedGPOfferSellerAggregateItem(gpOfferSellerAggregateItem);
  };

  const handleSellerItemDetailRowClick = (sellerItemDetail) => {
    setSelectedSellerItemDetail(sellerItemDetail);
    setSelectedProductName(sellerItemDetail.ProductName);
    setSelectedGrade(sellerItemDetail.Grade);
    // setSelectedState(sellerItemDetail.State); // Removed as selectedState is no longer used
  };

  const handleAMTPLBuyerRowClick = (amtplUser) => {
    setSelectedAMTPLBuyer(amtplUser);
  };

  const handleAMTPLGlobalPartnerRowClick = (amtplUser) => {
    setSelectedAMTPLGlobalPartner(amtplUser);
  };

  const handleAMTPLSellerRowClick = (amtplUser) => {
    setSelectedAMTPLSeller(amtplUser);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterTerms((prevTerms) => ({ ...prevTerms, [name]: value }));
    resetFilter();
  };

  const handleSearch = () => {
    resetFilter();
  };

  const handleReset = () => {
    setFilterTerms({ product: "", grade: "" });
    resetFilter();
  };

  // Reusable function to build VM Offers search parameters
  const buildVMOffersSearchParams = (rowStart = 0) => {
    const filterTerms = {};

    if (vmOffersFilters.product) {
      filterTerms.product = vmOffersFilters.product;
    }
    if (vmOffersFilters.grade) {
      filterTerms.grade = vmOffersFilters.grade;
    }
    if (vmOffersFilters.destinationCountry) {
      filterTerms.DestinationCountry = vmOffersFilters.destinationCountry;
    }

    // For date filtering
    if (vmOffersFilters.createdDate) {
      const searchDate = new Date(vmOffersFilters.createdDate);
      const formattedDate = searchDate.toISOString().split("T")[0];
      filterTerms.CreatedAtGT = formattedDate + " 00:00:00"; // Start of the day
      filterTerms.CreatedAtLT = formattedDate + " 23:59:59"; // End of the day
    }

    // For quantity range filtering
    if (vmOffersFilters.quantity) {
      const [min, max] = vmOffersFilters.quantity.split("-");
      if (min === "Above") {
        filterTerms.QuantityGT = max;
      } else {
        filterTerms.QuantityGT = min;
        filterTerms.QuantityLT = max;
      }
    }

    return {
      filterTerms: filterTerms,
      userOrder: "CreatedAt DESC, OfferSequenceID DESC",
      rowStart: rowStart,
      pageSize: pageSize,
    };
  };

  // Check if VM Offers filters are currently active
  const hasActiveVMOffersFilters = () => {
    return (
      vmOffersFilters.product ||
      vmOffersFilters.grade ||
      vmOffersFilters.createdDate ||
      vmOffersFilters.quantity ||
      vmOffersFilters.destinationCountry
    );
  };

  // New methods for View & Modify Offers filtering
  const handleVMOffersFilterChange = (e) => {
    const { name, value } = e.target;
    setVmOffersFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  const handleVMOffersSearch = () => {
    // Apply the VM Offers filters to search/filter the gpOffers data
    console.log("VM Offers Search with filters:", vmOffersFilters);

    // Reset page to 1 for new search
    setCurrentGPOfferPage(1);

    // Build search parameters using the reusable function
    const searchParams = buildVMOffersSearchParams(0);

    console.log("Searching with:", searchParams);
    fetchGPOffers(searchParams);
  };

  const handleVMOffersReset = () => {
    setVmOffersFilters({
      product: "",
      grade: "",
      createdDate: "",
      quantity: "",
      destinationCountry: "",
    });

    // Reset to original unfiltered data by reloading
    setCurrentGPOfferPage(1);

    console.log("VM Offers filters reset - reloading original data");
    fetchGPOffers(); // Call without any custom parameters to get unfiltered data
  };

  const resetEntitiesFilter = () => {
    setSelectedAMTPLBuyer(null);
    setSelectedAMTPLGlobalPartner(null);
    setSelectedAMTPLSeller(null);
    setCurrentAMTPLBuyerPage(1);
    setCurrentAMTPLGlobalPartnerPage(1);
    setCurrentAMTPLSellerPage(1);
  };

  const handleEntitiesFilterChange = (e) => {
    const { name, value } = e.target;
    setEntitiesFilterTerms((prevTerms) => ({ ...prevTerms, [name]: value }));
  };

  const handleEntitiesSearch = () => {
    reloadEntityData();
  };

  const handleEntitiesReset = () => {
    setEntitiesFilterTerms({
      name: "",
      company: "",
      location: "",
      zipcode: "",
      globalPartner: "",
    });
    resetEntitiesFilter();
  };

  const handleQueryRowClick = (query) => {
    setSelectedQuery(query);
  };

  const handleGenerateOffer = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "generateOffer",
        access_token: user.signInUserSession.idToken.jwtToken,
        product: products.find(
          (product) =>
            product.ProductName === selectedProductName &&
            product.Grade === selectedGrade
        ),
        destinationCountry: selectedCountry,
        originCountry: selectedOriginCountry,
        globalPartner: selectedGlobalPartner,
        buyer: selectedBuyer,
        minOfferQuantityMT: minOfferQuantityMT,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        setShowModalMsg("Succesfully created the aggregated offer.");
        console.log(`Creating automatic offer successful`);
        setShowModal(true);
      } else {
        console.error(
          `Error while generating offer: ${JSON.stringify(
            result.error || result
          )}`
        );
        setShowModalMsg(
          `Error while generating offer: ${JSON.stringify(
            result.error || result
          )}`
        );
        setShowModal(true);
      }
    } catch (error) {
      console.error(`Error while generating offer: ${JSON.stringify(error)}`);
      setShowModalMsg(`Error while generating offer: ${JSON.stringify(error)}`);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (selectedAMTPLUser) => {
    if (!selectedAMTPLUser) {
      console.error("No user selected");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "generatenewpassword",
        access_token: user.signInUserSession.idToken.jwtToken,
        amtplUser: selectedAMTPLUser,
      };

      const params = {
        FunctionName: `backendops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log(`Save action successful`, result);
        setShowModalMsg(`Generate and Send Password action successful`);
        setShowModal(true);
      } else {
        console.error(`Error updating User: ${JSON.stringify(result)}`);

        setShowModalMsg(`Error updating User: ${JSON.stringify(result)}`);
        setShowModal(true);
      }
    } catch (error) {
      console.error(`Error updating User: ${JSON.stringify(error)}`);
      setShowModalMsg(`Error updating User: ${JSON.stringify(error)}`);
      setShowModal(true);
    } finally {
      setLoading(false);
      reloadEntityData();
    }
  };

  const amtplUserSave = async (selectedAMTPLUser) => {
    if (!selectedAMTPLUser) {
      console.error("No user selected");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "updateAMTPLUser",
        access_token: user.signInUserSession.idToken.jwtToken,
        updateAMTPLUserInput: selectedAMTPLUser,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log(`Save action successful`, result);
        setShowModalMsg(`Save action successful`);
        setShowModal(true);
      } else {
        console.error(`Error updating User: ${JSON.stringify(result)}`);
        setShowModalMsg(`Error updating User: ${JSON.stringify(result)}`);
        setShowModal(true);
      }
    } catch (error) {
      console.error(`Error updating User: ${JSON.stringify(error)}`);
      setShowModalMsg(`Error updating User: ${JSON.stringify(error)}`);
      setShowModal(true);
    } finally {
      setLoading(false);
      reloadEntityData();
    }
  };

  const handleBuyerResetPassword = async () => {
    resetPassword(selectedAMTPLBuyer);
  };

  const handleBuyerSave = async () => {
    amtplUserSave(selectedAMTPLBuyer);
  };

  const handleGlobalPartnerResetPassword = async () => {
    resetPassword(selectedAMTPLGlobalPartner);
  };

  const handleGlobalPartnerSave = async () => {
    amtplUserSave(selectedAMTPLGlobalPartner);
  };

  const handleSellerResetPassword = async () => {
    resetPassword(selectedAMTPLSeller);
  };

  const handleSellerSave = async () => {
    amtplUserSave(selectedAMTPLSeller);
  };

  const handleApprove = async () => {
    if (!selectedSellerItemDetail) {
      console.error("No Seller Item selected");
      return;
    }
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "approveOffer",
        access_token: user.signInUserSession.idToken.jwtToken,
        sellerItemInput: selectedSellerItemDetail,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log(`Save action successful`, result);
        setShowModalMsg(`Save action successful`);
        setShowModal(true);
        fetchSellerItemDetails();
      } else {
        console.error(`Error updating Seller Item: ${JSON.stringify(result)}`);
        setShowModalMsg(
          `Error updating Seller Item: ${JSON.stringify(result)}`
        );
        setShowModal(true);
      }
    } catch (error) {
      console.error(`Error updating Seller Item: ${JSON.stringify(error)}`);
      setShowModalMsg(`Error updating Seller Item: ${JSON.stringify(error)}`);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  function isValidNumber(value) {
    return value !== "" && !isNaN(value);
  }

  const handleAMTPLBuyerChange = (event) => {
    const { id, value } = event.target;
    const floatFields = [];
    const intFields = ["Age"];
    let newAMTPLUser = {
      ...selectedAMTPLBuyer,
    };
    if (floatFields.includes(id)) {
      if (isValidNumber(value)) {
        newAMTPLUser[id] = parseFloat(value);
      } else {
        newAMTPLUser[id] = 0;
      }
    } else if (intFields.includes(id)) {
      if (isValidNumber(value)) {
        newAMTPLUser[id] = parseInt(value);
      } else {
        newAMTPLUser[id] = 0;
      }
    } else {
      newAMTPLUser[id] = value;
    }
    setSelectedAMTPLBuyer(newAMTPLUser);
  };

  const handleAMTPLGlobalPartnerChange = (event) => {
    const { id, value } = event.target;
    const floatFields = [];
    const intFields = ["Age"];
    let newAMTPLUser = {
      ...selectedAMTPLGlobalPartner,
    };
    if (floatFields.includes(id)) {
      if (isValidNumber(value)) {
        newAMTPLUser[id] = parseFloat(value);
      } else {
        newAMTPLUser[id] = 0;
      }
    } else if (intFields.includes(id)) {
      if (isValidNumber(value)) {
        newAMTPLUser[id] = parseInt(value);
      } else {
        newAMTPLUser[id] = 0;
      }
    } else {
      newAMTPLUser[id] = value;
    }
    setSelectedAMTPLGlobalPartner(newAMTPLUser);
  };

  const handleAMTPLSellerChange = (event) => {
    const { id, value } = event.target;
    const floatFields = [];
    const intFields = ["Age"];
    let newAMTPLUser = {
      ...selectedAMTPLSeller,
    };
    if (floatFields.includes(id)) {
      if (isValidNumber(value)) {
        newAMTPLUser[id] = parseFloat(value);
      } else {
        newAMTPLUser[id] = 0;
      }
    } else if (intFields.includes(id)) {
      if (isValidNumber(value)) {
        newAMTPLUser[id] = parseInt(value);
      } else {
        newAMTPLUser[id] = 0;
      }
    } else {
      newAMTPLUser[id] = value;
    }
    setSelectedAMTPLSeller(newAMTPLUser);
  };

  const resetFilter = () => {
    setSelectedSellerItemDetail(null);
    setSelectedProductName("");
    setSelectedGrade("");
    // setSelectedState(""); // Removed as selectedState is no longer used
    setCurrentSellerItemDetailPage(1);
    //setCurrentPage(1);
    setSelectedGPOffer(null);
    setCurrentGPOfferPage(1);
    setSelectedQuery(null);
    setQueryPage(1);
    // setSellerItemDetailQueries([]); // Removed as queries are no longer used
  };

  // Function to handle radio button change
  const handleOptionChange = (e) => {
    console.log(e.target.value);
    if (e.target.value === "requirement") {
      navigate("/amtpl/requirement");
    } else if (e.target.value === "addrequirement") {
      navigate("/amtpl/addrequirement");
    } else {
      setSelectedOption(e.target.value);
    }
  };
  const handleDataFilterChange = useCallback(
    (event) => {
      const selectedValue = event.target.value;
      setSelectedOption(selectedValue);
      console.log("Selected filter:", selectedValue);
      if (
        selectedValue === "products" ||
        selectedValue === "offers" ||
        selectedValue === "entities"
      ) {
        navigate("/amtpl", { state: { selectedFilter: selectedValue } });
        console.log(selectedValue);
      } else if (selectedValue === "Add Requirement") {
        navigate("/amtpl/addrequirement", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Requirement Approval") {
        navigate("/amtpl/requirement", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Product Offers") {
        navigate("/amtpl/productofferscharges", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Inland Shipping") {
        navigate("/amtpl/inlandshipping", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Country wise Product") {
        navigate("/amtpl/counrywiseproduct", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Product Category") {
        navigate("/amtpl/productcategory", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Product") {
        navigate("/amtpl/product", {
          state: { selectedFilter: selectedValue },
        });
      }
    },
    [navigate]
  );
  console.log('============== selectedSellerItemDetail===',selectedSellerItemDetail);

  return (
    <div className="amtpl-dashboard">
      <Header activeUser={activeUser} setLoading={setLoading} />
      <div className="content">
        <SidebarCommon
          selectedFilter={selectedOption}
          handleDataFilterChange={handleDataFilterChange}
        />
        <main className="main-content">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-9 col-12">
              {selectedOption === "products" && (
                <>
                  <div className="offers-search row">
                    <div className="col-lg-3 col-sm-4 col-6">
                      <select
                        className="form-control form-select"
                        id="product"
                        name="product"
                        value={filterTerms.product || ""}
                        onChange={handleFilterChange}
                      >
                        <option value="">Select a product</option>
                        {[
                          ...new Set(
                            products.map((product) => product.ProductName)
                          ),
                        ].map((product) => (
                          <option key={product} value={product}>
                            {product}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-lg-3 col-sm-4 col-6">
                      <select
                        className="form-control form-select"
                        id="grade"
                        name="grade"
                        value={filterTerms.grade || ""}
                        onChange={handleFilterChange}
                      >
                        <option value="">Select a Grade</option>
                        {products
                          .filter(
                            (product) =>
                              product.ProductName === filterTerms.product
                          )
                          .map((product) => (
                            <option key={product.Grade} value={product.Grade}>
                              {product.Grade}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-lg-3 col-sm-4 col-6">
                      <select
                        className="form-control form-select"
                        id="state"
                        name="state"
                        value={filterTerms.state || ""}
                        onChange={handleFilterChange}
                      >
                        <option value="">Select State</option>
                        {states.map((state) => (
                          <option key={state} value={state}>
                            {state}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-lg-3 col-sm-4 col-6">
                      <button onClick={handleSearch} className="mx-3 d-inline">
                        Search
                      </button>
                      <button onClick={handleReset} className="d-inline">
                        Reset
                      </button>
                    </div>
                  </div>

                  <section className="offers">
                    <table>
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Grade</th>
                          <th>Quantity</th>
                          <th>Price</th>
                          <th>State</th>
                          <th>Seller Type</th>
                          <th>Seller name</th>
                          <th>Created On</th>
                          <th>Expires On</th>
                          <th>Approved</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sellerItemDetails.map((sellerItemDetail) => (
                          <tr
                            key={sellerItemDetail.SellerItemID}
                            onClick={() =>
                              handleSellerItemDetailRowClick(sellerItemDetail)
                            }
                            className={
                              selectedSellerItemDetail &&
                              selectedSellerItemDetail?.SellerItemID ===
                                sellerItemDetail.SellerItemID
                                ? "selected"
                                : ""
                            }
                          >
                            <td>{sellerItemDetail.ProductName}</td>
                            <td>{sellerItemDetail.Grade}</td>
                            <td>{sellerItemDetail.Quantity}</td>
                            <td>{sellerItemDetail.Price}</td>
                            <td>{sellerItemDetail.State}</td>
                            <td>{sellerItemDetail.SellerType}</td>
                            <td>{sellerItemDetail.SellerEmailID}</td>
                            <td>{sellerItemDetail.CreatedAt}</td>
                            <td>{sellerItemDetail.Expires}</td>
                            <td>{sellerItemDetail.Approved}</td>
                          </tr>
                        ))}
                        {sellerItemDetails.length === 0 && (
                          <tr>
                            <td colSpan="7">No Seller items available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div className="pagination">
                      <button
                        onClick={() =>
                          handleSellerItemDetailPageChange(
                            currentSellerItemDetailPage - 1
                          )
                        }
                        disabled={currentSellerItemDetailPage === 1}
                      >
                        {"<"}
                      </button>
                      {Array.from(
                        { length: totalSellerItemDetailPages },
                        (_, index) => (
                          <button
                            key={index + 1}
                            onClick={() =>
                              handleSellerItemDetailPageChange(index + 1)
                            }
                            className={
                              currentSellerItemDetailPage === index + 1
                                ? "active"
                                : ""
                            }
                          >
                            {index + 1}
                          </button>
                        )
                      )}
                      <button
                        onClick={() =>
                          handleSellerItemDetailPageChange(
                            currentSellerItemDetailPage + 1
                          )
                        }
                        disabled={
                          currentSellerItemDetailPage ===
                          totalSellerItemDetailPages
                        }
                      >
                        {">"}
                      </button>
                    </div>
                  </section>

                  <section className="product-details">
                    <div className="tabs">
                      <button
                        className={activeTab === "offerInformation" ? "active" : ""}
                        onClick={() => handleTabClick("offerInformation")}
                      >
                        Offer Information
                      </button>
                      <button
                        className={activeTab === "commodityDetails" ? "active" : ""}
                        onClick={() => handleTabClick("commodityDetails")}
                      >
                        Commodity Details
                      </button>
                      <button
                        className={activeTab === "quantityPackaging" ? "active" : ""}
                        onClick={() => handleTabClick("quantityPackaging")}
                      >
                        Quantity & Packaging
                      </button>
                      <button
                        className={activeTab === "deliveryLogistic" ? "active" : ""}
                        onClick={() => handleTabClick("deliveryLogistic")}
                      >
                        Delivery & Logistic
                      </button>
                      <button
                        className={activeTab === "pricing" ? "active" : ""}
                        onClick={() => handleTabClick("pricing")}
                      >
                        Pricing, Payment & Guarantee
                      </button>
                      <button
                        className={activeTab === "others" ? "active" : ""}
                        onClick={() => handleTabClick("others")}
                      >
                        Others
                      </button>
                    </div>

                    {activeTab === "offerInformation" && (
                      <div className="tab-content active">
                        <div className="row">
                          <div className="col-lg-9 col-sm-9 col-6">
                            <div className="row">
                             
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="offerStatus">Offer Status</label>
                                <input
                                  id="offerStatus"
                                  type="text"
                                  value={selectedGPOffer?.OfferStatus || "Indicative"}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="CreatedAt">Creation Date</label>
                                <input
                                  id="CreatedAt"
                                  type="text"
                                  value={formatDateToMMDDYY(selectedSellerItemDetail?.CreatedAt)}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="offerExpiryDate">Expiry Date</label>
                                <input
                                  id="Expires"
                                  type="text"
                                  value={formatDateToMMDDYY(selectedSellerItemDetail?.Expires)}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-6 col-sm-8 col-12">
                                <label htmlFor="sellerInformation">Seller Information</label>
                                <input
                                  id="sellerInformation"
                                  type="text"
                                  value={selectedGPOffer?.Sellerinformation || "AMTPL"}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-3 col-6">
                            <div className="actions">
                              <div className="row">
                                <div className="col-12 mb-2">
                                  <button
                                    disabled={!selectedSellerItemDetail}
                                    onClick={handleApprove}
                                  >
                                    Approve
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "commodityDetails" && (
                      <div className="tab-content active">
                        <div className="row">
                          <div className="col-lg-9 col-sm-9 col-6">
                            <div className="row">
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="product">Product</label>
                                <input
                                  id="grade"
                                  type="product"
                                  value={selectedProductName || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="hsCode">HS Code</label>
                                <input
                                  id="hsCode"
                                  type="text"
                                  value={selectedGPOffer?.HsCode || ""}
                                  className="form-control"
                                  readOnly
                                  placeholder=""
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="grade">Grade / Quality</label>
                                 <input
                                  id="grade"
                                  type="text"
                                  value={selectedGrade || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="variety">Variety</label>
                                <input
                                  id="variety"
                                  type="text"
                                  value={selectedGPOffer?.Variety || ""}
                                  className="form-control"
                                  readOnly
                                  placeholder=""
                                />
                              </div>
                              <div className="col-lg-6 col-sm-8 col-12">
                                <label htmlFor="productSpecifications">Product Specifications</label>
                                <textarea
                                  id="productSpecifications"
                                  name="productSpecifications"
                                  maxLength="4000"
                                  className="form-control"
                                  rows="4"
                                  value={selectedSellerItemDetail?.productSpecifications || ""}
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-6 col-sm-4 col-12">
                                <label htmlFor="originCountry">Origin Country</label>
                                 <input
                                  id="Country "
                                  type="text"
                                  value={selectedSellerItemDetail?.Country || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-3 col-6">
                            <div className="actions">
                              <div className="row">
                                <div className="col-12 mb-2">
                                  <button
                                    disabled={!selectedSellerItemDetail && !selectedGPOffer}
                                    onClick={handleApprove}
                                  >
                                    Approve
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "quantityPackaging" && (
                      <div className="tab-content active">
                        <div className="row">
                          <div className="col-lg-9 col-sm-9 col-6">
                            <div className="row">
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="offeredQuantity">Offered Quantity</label>
                                <input
                                  id="offeredQuantity"
                                  type="number"
                                  value={selectedSellerItemDetail?.Quantity || ""}
                                  className="form-control"
                                  readOnly
                                  placeholder="Numeric"
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="packagingType">Packaging Type</label>
                                <select
                                  id="packagingType"
                                  className="form-control"
                                  value={selectedGPOffer?.PackagingType || "Bulk"}
                                  readOnly
                                >
                                  <option value="Bulk">Bulk</option>
                                  <option value="Bags">Bags</option>
                                </select>
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="packagingSize">Packaging Size</label>
                                <input
                                  id="packagingSize"
                                  type="text"
                                  value={selectedGPOffer?.PackagingSize || "50kg"}
                                  className="form-control"
                                  readOnly
                                  placeholder="e.g., 50kg"
                                />
                              </div>
                              <div className="col-lg-9 col-sm-8 col-12">
                                <label htmlFor="additionalPackagingNotes">Additional Packaging Notes</label>
                                <textarea
                                  id="additionalPackagingNotes"
                                  value={selectedGPOffer?.AdditionalPackagingNotes || ""}
                                  className="form-control"
                                  readOnly
                                  rows="3"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-3 col-6">
                            <div className="actions">
                              <div className="row">
                                <div className="col-12 mb-2">
                                  <button
                                    disabled={!selectedGPOffer}
                                    onClick={handleApprove}
                                  >
                                    Approve
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "deliveryLogistic" && (
                      <div className="tab-content active">
                        <div className="row">
                          <div className="col-lg-9 col-sm-9 col-6">
                            <div className="row">
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="shippingMethodPreference">Shipping Method Preference</label>
                                <select
                                  id="shippingMethodPreference"
                                  className="form-control"
                                  value={selectedGPOffer?.ShippingMethodPreference || "Road"}
                                  readOnly
                                >
                                  <option value="Road">Road</option>
                                  <option value="Rail">Rail</option>
                                  <option value="Ocean">Ocean</option>
                                </select>
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="loadingPort">Loading Port</label>
                                <input
                                  id="State "
                                  type="text"
                                  value={selectedSellerItemDetail?.State || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="deliveryPort">Delivery Port</label>
                                <input
                                  id="deliveryPort"
                                  type="text"
                                  value={selectedGPOffer?.DeliveryPort || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="loadingLocation">Loading Location</label>
                                 <input
                                  id="Currency "
                                  type="text"
                                  value={selectedSellerItemDetail?.State || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="deliveryLocation">Delivery Location</label>
                                <input
                                  id="deliveryLocation"
                                  type="text"
                                  value={selectedGPOffer?.DeliveryLocation || ""}
                                  className="form-control"
                                  readOnly
                                  placeholder=""
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="incoterms">Incoterms</label>
                                <select
                                  id="incoterms"
                                  className="form-control"
                                  value={selectedGPOffer?.INCO || " "}
                                  readOnly
                                >
                                  <option value="FOB">FOB</option>
                                  <option value="CIF">CIF</option>
                                  <option value="EXW">EXW</option>
                                </select>
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="transitTime">Transit Time</label>
                                <input
                                  id="transitTime"
                                  type="text"
                                  value={selectedGPOffer?.TransitTime || "60 Days Approx"}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="partialDeliveryAllowed">Partial Delivery Allowed?</label>
                                <select
                                  id="partialDeliveryAllowed"
                                  className="form-control"
                                  value={selectedGPOffer?.PartialDeliveryAllowed || "No"}
                                  readOnly
                                >
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </select>
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="dailyUnloadingCapacity">Daily Unloading Capacity</label>
                                <input
                                  id="dailyUnloadingCapacity"
                                  type="text"
                                  value={selectedGPOffer?.DailyUnloadingCapacity || "No"}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="unloadingResponsibility">Unloading Responsibility</label>
                                <select
                                  id="unloadingResponsibility"
                                  className="form-control"
                                  value={selectedGPOffer?.UnloadingResponsibility || "Buyer"}
                                  readOnly
                                >
                                  <option value="Buyer">Buyer</option>
                                  <option value="Supplier">Supplier</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-3 col-6">
                            <div className="actions">
                              <div className="row">
                                <div className="col-12 mb-2">
                                  <button
                                    disabled={!selectedGPOffer}
                                    onClick={handleApprove}
                                  >
                                    Approve
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "pricing" && (
                      <div className="tab-content active">
                        <div className="row">
                          <div className="col-lg-9 col-sm-9 col-6">
                            <div className="row">
                              
                              <div className="col-lg-3 col-sm-4 col-6">
                                 <label>Currency</label>
                                <input
                                  id="Currency "
                                  type="text"
                                  value={selectedSellerItemDetail?.Currency || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                 <label>Price/ MT (INR)</label>
                                <input
                                  id="Price"
                                  type="text"
                                  value={selectedSellerItemDetail?.Price || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="fobSalePrice">FOB Sale Price (Per MT)</label>
                                <input
                                  id="fobSalePrice"
                                  type="number"
                                  value={selectedGPOffer?.FOBSalePrice || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="totalFobSalePrice">Total FOB Sale Price</label>
                                <input
                                  id="totalFobSalePrice"
                                  type="number"
                                  value={selectedGPOffer?.TotalFOBSalePrice || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                             
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="shippingInsuranceCharges">Shipping & Insurance Charges (Per MT)</label>
                                <input
                                  id="shippingInsuranceCharges"
                                  type="number"
                                  value={selectedGPOffer?.ShippingInsuranceCharges || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="cifSalePrice">CIF Sale Price (Per MT)</label>
                                <input
                                  id="cifSalePrice"
                                  type="number"
                                  value={selectedGPOffer?.CIFSalePrice || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="totalCifPrice">Total CIF Price</label>
                                <input
                                  id="totalCifPrice"
                                  type="number"
                                  value={selectedGPOffer?.TotalCIFPrice || ""}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-3 col-sm-4 col-6">
                                <label htmlFor="preferredPaymentMethod">Preferred Payment Method</label>
                                <select
                                  id="preferredPaymentMethod"
                                  className="form-control"
                                  value={selectedGPOffer?.PreferredPaymentMethod || "LC"}
                                  readOnly
                                >
                                  <option value="LC">LC</option>
                                  <option value="SBLC">SBLC</option>
                                  <option value="Advance">Advance</option>
                                </select>
                              </div>
                              <div className="col-lg-9 col-sm-8 col-12">
                                <label htmlFor="paymentTerms">Payment Terms</label>
                                <textarea
                                  id="paymentTerms"
                                  value={selectedGPOffer?.PaymentTerms || ""}
                                  className="form-control"
                                  readOnly
                                  rows="3"
                                  placeholder="Payment terms details..."
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-3 col-6">
                            <div className="actions">
                              <div className="row">
                                <div className="col-12 mb-2">
                                  <button
                                    disabled={!selectedGPOffer}
                                    onClick={handleApprove}
                                  >
                                    Approve
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "others" && (
                      <div className="tab-content active">
                        <div className="row">
                          <div className="col-lg-9 col-sm-9 col-6">
                            <div className="row">
                              <div className="col-lg-12 col-sm-12 col-12">
                                <label htmlFor="specialInstructionsBuyer">Special Instructions for Buyer</label>
                                <textarea
                                  id="specialInstructionsBuyer"
                                  value={selectedGPOffer?.SpecialInstructionsBuyer || ""}
                                  className="form-control"
                                  readOnly
                                  rows="4"
                                  placeholder="Special instructions for the buyer..."
                                />
                              </div>
                              <div className="col-lg-12 col-sm-12 col-12">
                                <label htmlFor="internalComments">Internal Comments (Not Visible to Buyers)</label>
                                <textarea
                                  id="internalComments"
                                  value={selectedGPOffer?.Internalcomments || ""}
                                  className="form-control"
                                  readOnly
                                  rows="4"
                                  placeholder="Internal comments for team use only..."
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-3 col-6">
                            <div className="actions">
                              <div className="row">
                                <div className="col-12 mb-2">
                                  <button
                                    disabled={!selectedGPOffer}
                                    onClick={handleApprove}
                                  >
                                    Approve
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </section>
                </>
              )}

              {selectedOption === 'offers' && (
                <div>
                <section className="product-details">
                  <div className="tabs">
                    <button
                      className={activeOffersTab === 'vmOffers' ? 'active' : ''}
                      onClick={() => handleOffersTabClick('vmOffers')}
                    >
                      View & Modify Offers
                    </button>
                    <button
                      className={activeOffersTab === 'goAutomatic' ? 'active' : ''}
                      onClick={() => handleOffersTabClick('goAutomatic')}
                    >
                      Generate Offers (Automatic)
                    </button>
                  </div>

                  {activeOffersTab === 'vmOffers' && (
                    <div className="tab-content active">
                      {/* Comment: New View & Modify Offers search and filter functionality */}
                        <div className='row' style={{ fontSize: '12px' }}>
                          <div className='offers-search row'>
                            <div className='col-lg-2 col-sm-4 col-md-6 '>
                              <label>Product</label>
                              <select
                                className="form-control form-select"
                                id="product"
                                name="product"
                                value={vmOffersFilters.product || ''}
                                onChange={handleVMOffersFilterChange}
                                style={{ height: '40px',fontSize: '12px !important'  }}
                              >
                                <option value="">Select a product</option>
                                {[...new Set(products.map(product => product.ProductName))].map((product) => (
                                  <option key={product} value={product}>{product}</option>
                                ))}
                              </select>
                            </div>

                            <div className='col-lg-2 col-sm-4 col-md-6 margin-0'>
                              <label>Grade</label>
                              <select
                                className="form-control form-select"
                                id="grade"
                                name="grade"
                                value={vmOffersFilters.grade || ''}
                                onChange={handleVMOffersFilterChange}
                                style={{ height: '40px',fontSize: '12px !important'  }}
                              >
                                <option value="">Select a Grade</option>
                                {products
                                  .filter(product => product.ProductName === vmOffersFilters.product)
                                  .map((product) => (
                                    <option key={product.Grade} value={product.Grade}>{product.Grade}</option>
                                  ))}
                              </select>
                            </div>

                            <div className='col-lg-2 col-sm-4 col-md-6'>
                              <label>Created Date</label>
                              <input
                                type="date"
                                className="form-control"
                                id="createdDate"
                                name="createdDate"
                                value={vmOffersFilters.createdDate || ''}
                                onChange={handleVMOffersFilterChange}
                                style={{ height: '40px',fontSize: '12px !important'  }}
                              />
                            </div>

                            <div className='col-lg-2 col-sm-4 col-md-6 margin-0'>
                              <label>Quantity (MT)</label>
                              <select
                                className="form-control form-select"
                                id="quantity"
                                name="quantity"
                                value={vmOffersFilters.quantity || ''}
                                onChange={handleVMOffersFilterChange}
                                style={{ height: '40px',fontSize: '12px !important'  }}
                              >
                                <option value="">Select Range</option>
                                <option value="50-100">50-100 MT</option>
                                <option value="100-200">100-200 MT</option>
                                <option value="200-500">200-500 MT</option>
                                <option value="Above-500">Above 500 MT</option>
                              </select>
                            </div>

                            <div className='col-lg-2 col-sm-4 col-md-6 '>
                              <label>Destination Country</label>
                              <select
                                className="form-control form-select"
                                id="destinationCountry"
                                name="destinationCountry"
                                value={vmOffersFilters.destinationCountry || ''}
                                onChange={handleVMOffersFilterChange}
                                style={{ height: '40px',fontSize: '12px !important'  }}
                              >
                                <option value="">Select Country</option>
                                {countries.map((country) => (
                                  <option key={country.Value} value={country.Value}>{country.Value}</option>
                                ))}
                              </select>
                            </div>

                            <div className='col-lg-2 col-sm-4 col-md-6 margin-0 d-flex' >
                              <div className="button-group offer-serch0button">
                                <button
                                  onClick={handleVMOffersSearch}
                                  className='btn btn-primary'
                                  style={{ height: '40px' }}
                                >
                                  Search
                                </button>
                                <button
                                  onClick={handleVMOffersReset}
                                  className='btn btn-secondary'
                                  style={{ height: '40px' }}
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      
                      <div className='row'>
                        <section className="offers">
                          <table>
                            <thead>
                              <tr>
                                <th>Offer Id</th>
                                <th>Created</th>
                                <th>Expires</th>
                                <th>Product</th>
                                <th>Grade</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Destination</th>
                                <th>Approved</th>
                                <th>Offer Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              {gpOffers.map((gpOffer) => (
                                <tr
                                  key={gpOffer.GPOfferID}
                                  onClick={() => handleGPOfferRowClick(gpOffer)}
                                  className={selectedGPOffer && selectedGPOffer?.GPOfferID === gpOffer.GPOfferID ? 'selected' : ''}
                                >
                                  <td>{gpOffer.OfferSequenceID}</td>
                                  <td>{gpOffer.CreatedAt}</td>
                                  <td>{gpOffer.Expires}</td>
                                  <td>{gpOffer.ProductName}</td>
                                  <td>{gpOffer.Grade}</td>
                                  <td>{gpOffer.Quantity}</td>
                                  <td>{gpOffer.Price}</td>
                                  <td>{gpOffer.DestinationCountry}</td>
                                  <td>{gpOffer.Approved}</td>
                                  <td>{gpOffer.OfferType}</td>
                                </tr>
                              ))}
                              {gpOffers.length === 0 && (
                                <tr>
                                  <td colSpan="10">No GP Offers available</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          {totalGPOfferPages > 0 && (
                            <div className="pagination">
                              <button onClick={() => handleGPOfferPageChange(currentGPOfferPage - 1)} disabled={currentGPOfferPage === 1}>{'<'}</button>
                              {Array.from({ length: totalGPOfferPages }, (_, index) => (
                                <button
                                  key={index + 1}
                                  onClick={() => handleGPOfferPageChange(index + 1)}
                                  className={currentGPOfferPage === index + 1 ? 'active' : ''}
                                >
                                  {index + 1}
                                </button>
                              ))}
                              <button onClick={() => handleGPOfferPageChange(currentGPOfferPage + 1)} disabled={currentGPOfferPage === totalGPOfferPages}>{'>'}</button>
                            </div>
                          )}
                        </section>
                      </div>
                      {selectedGPOffer && 
                        <>
                          <div className='row'>
                          <label htmlFor="firstName" className="offers">Offer Details for Offer: {selectedGPOffer.OfferSequenceID} - {selectedGPOffer.ProductName} - {selectedGPOffer.Grade} - {selectedGPOffer.Quantity} MT - {selectedGPOffer.DestinationCountry}</label>
                            <section className="offers">
                              <table>
                                <thead>
                                  <tr>
                                    <th>Seller Type</th>
                                    <th>Seller Name</th>
                                    <th>State</th>
                                    <th>Quantity (MT)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {gpOfferSellerAggregateItems && gpOfferSellerAggregateItems.map((gpOfferSellerAggregateItem) => (
                                    <tr
                                      key={gpOfferSellerAggregateItem.SellerItemID}
                                      onClick={() => handleGPOfferSellerAggregateItemRowClick(gpOfferSellerAggregateItem)}
                                      className={selectedGPOfferSellerAggregateItem && selectedGPOfferSellerAggregateItem?.SellerItemID === gpOfferSellerAggregateItem.SellerItemID ? 'selected' : ''}
                                    >
                                      <td>{gpOfferSellerAggregateItem.SellerType}</td>
                                      <td>{gpOfferSellerAggregateItem.SellerName}</td>
                                      <td>{gpOfferSellerAggregateItem.State}</td>
                                      <td>{gpOfferSellerAggregateItem.Quantity}</td>
                                    </tr>
                                  ))}
                                  {gpOfferSellerAggregateItems.length === 0 && (
                                    <tr>
                                      <td colSpan="7">No aggregate items available</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              <div className="pagination">
                                <button onClick={() => handleGPOfferSellerAggregatePageChange(currentGPOfferSellerAggregatePage - 1)} disabled={currentGPOfferSellerAggregatePage === 1}>{'<'}</button>
                                {Array.from({ length: totalGPOfferSellerAggregatePages }, (_, index) => (
                                  <button
                                    key={index + 1}
                                    onClick={() => handleGPOfferSellerAggregatePageChange(index + 1)}
                                    className={currentGPOfferSellerAggregatePage === index + 1 ? 'active' : ''}
                                  >
                                    {index + 1}
                                  </button>
                                ))}
                                <button onClick={() => handleGPOfferSellerAggregatePageChange(currentGPOfferSellerAggregatePage + 1)} disabled={currentGPOfferSellerAggregatePage === totalGPOfferSellerAggregatePages}>{'>'}</button>
                              </div>
                            </section>
                          </div>
                          <div className='row'>
                            <table class="datatable">
                              <tr class="dataheader">
                                <th colspan="1">Pricing Item</th>
                                <th rowspan="1">Pricing Component</th>
                                <th rowspan="1">Amount (Rs)</th>
                                <th rowspan="1">Amount (USD)</th>
                              </tr>
                              <tr class="primerow">
                                <td>Seller's Quantity (MT)</td>
                                <td className='currency right'>{formatData(sellersQuantity)}</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr class="altrow">
                                <td>Seller's Price /MT (Rs.)</td>
                                <td className='currency right'>{formatData(sellersPrice)}</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr class="primerow">
                                <td>Seller's Total Price</td>
                                <td></td>
                                <td className='currency right'>{formatData(sellersPriceForQuantity)}</td>
                                <td className='currency right'>{formatData(sellersPriceForQuantity * INRToUsd)}</td>
                              </tr>
                              <tr class="altrow">
                                <td>AgroPreneur's Charges</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.APCommissionPercentage )}%</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.APCommission)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.APCommission * INRToUsd)}</td>
                              </tr>
                              <tr class="primerow">
                                <td>Sorting & Grading Charges</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.SortGradeChargedPercentage)}%</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.SortGradeCharged)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.SortGradeCharged * INRToUsd)}</td>
                              </tr>
                              <tr class="altrow">
                                <td>Operations & Finance Charges</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.OpsFinChargesPercentage)}%</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.OpsFinCharges)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.OpsFinCharges * INRToUsd)}</td>
                              </tr>
                              <tr class="altrow">
                                <td>Inland Transport Charges</td>
                                <td className='currency right'>{selectedGPOffer?.InlandTransport ? formatData(selectedGPOffer?.InlandTransport/sellersQuantity) : 0}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.InlandTransport)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.InlandTransport * INRToUsd)}</td>
                              </tr>
                              <tr class="primerow bold-font">
                                <td>Seller's BASE Price</td>
                                <td></td>
                                <td className='currency right'>{formatData(selectedGPOffer?.BasePrice)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.BasePrice * INRToUsd)}</td>
                              </tr>
                              <tr class="altrow">
                                <td>Margin</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.MarginPercentage)}%</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.Margin)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.Margin * INRToUsd)}</td>
                              </tr>
                              <tr class="primerow bold-font">
                                <td>FOB Sale Price</td>
                                <td></td>
                                <td className='currency right'>{formatData(selectedGPOffer?.FOBSalePrice)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.FOBSalePrice * INRToUsd)}</td>
                              </tr>
                              <tr class="altrow">
                                <td>Export Duty</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.ExportDutyPercentage )}%</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.ExportDuty)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.ExportDuty * INRToUsd)}</td>
                              </tr>
                              <tr class="altrow">
                                <td>Shipping & Insurance</td>
                                <td className='currency right'>Rs. {formatData(selectedGPOffer?.ShippingInsurancePercentage)} / MT</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.ShippingInsurance)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.ShippingInsurance * INRToUsd)}</td>
                              </tr>
                              <tr class="altrow">
                                <td>GST (Local Taxes)</td>
                                <td></td>
                                <td className='currency right'>{formatData(selectedGPOffer?.GST)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.GST * INRToUsd)}</td>
                              </tr>
                              <tr class="primerow bold-font">
                                <td>CIF Sale Price</td>
                                <td></td>
                                <td className='currency right'>{formatData(selectedGPOffer?.CIFSalePrice)}</td>
                                <td className='currency right'>{formatData(selectedGPOffer?.CIFSalePrice * INRToUsd)}</td>
                              </tr>
                            </table>
                          </div>
                        </>
                      }
                    </div>
                  )}

                  {activeOffersTab === 'goAutomatic' && (
                    <div className="tab-content active">
                      <div className='row'>
                        <div>
                        <section className="buyer-details">
                          <div className="tab-content active">
                            <div className='row'>
                              <div className='col-lg-9 col-sm-9 col-6'>
                                <div className='row'>
                                  <div className='col-lg-3 col-sm-4 col-6'>
                                    <label htmlFor="product">Product</label>
                                    <select className="form-control form-select" id="product" value={selectedProductName || ''} onChange={handleProductChange}>
                                      <option value="">Select a product</option>
                                      {[...new Set(products.map(product => product.ProductName))].map((product) => (
                                        <option key={product} value={product}>{product}</option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className='col-lg-3 col-sm-4 col-6'>
                                    <label htmlFor="grade">Product Grade</label>
                                    <select className="form-control form-select" id="grade" value={selectedGrade || ''} onChange={handleGradeChange}>
                                      <option value="">Select a Grade</option>
                                      {products.filter(product => product.ProductName === selectedProductName).map((product) => (
                                        <option key={product.Grade} value={product.Grade}>{product.Grade}</option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className='col-lg-3 col-sm-4 col-6'>
                                    <label htmlFor="grade">Destination Countries</label>
                                    <select className="form-control form-select" id="grade" value={selectedCountry || ''} onChange={handleCountryChange}>
                                      <option value="">Select a Country</option>
                                      {countries.map((country) => (
                                        <option key={country.Value} value={country.Value}>{country.Value}</option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className='col-lg-3 col-sm-4 col-6'>
                                    <label htmlFor="grade">Origin Country</label>
                                    <input type="text" readOnly value={selectedOriginCountry} className='form-control' />
                                  </div>
                                  <div className='col-lg-3 col-sm-4 col-6'>
                                    <label htmlFor="grade">Global Partner</label>
                                    <select className="form-control form-select" id="globalPartner" name="globalPartner" value={selectedGlobalPartner || ''} onChange={handleGlobalPartnerChange}>
                                      <option value="">Select Global Partner</option>
                                      {[...new Set(globalPartners)].map((partner) => {
                                        const match = partner.match(/<([^>]+)>/);  // Regex to extract content within <>
                                        const keyAndValue = match ? match[1] : ''; // Extract content if present
                                        return (
                                          <option key={keyAndValue} value={keyAndValue}>{partner}</option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                  <div className='col-lg-3 col-sm-4 col-6'>
                                    <label htmlFor="grade">Buyer</label>
                                    <select className="form-control form-select" id="buyer" name="buyer" value={selectedBuyer || ''} onChange={handleBuyerChange}>
                                      <option value="">Select Buyer</option>
                                      {[...new Set(buyers)].map((buyer) => {
                                        const match = buyer.match(/<([^>]+)>/);  // Regex to extract content within <>
                                        const keyAndValue = match ? match[1] : ''; // Extract content if present
                                        return (
                                          <option key={keyAndValue} value={keyAndValue}>{buyer}</option>
                                        );
                                      })}
                                    </select>
                                  </div>

                                  <div className='col-lg-3 col-sm-4 col-6'>
                                    <label>Min Offer Quantity (MT)</label>
                                    <input type="text" value={minOfferQuantityMT} className='form-control' onChange={handleMinOfferQuantityMTChange}/>
                                  </div>
                                </div>
                              </div>
                              <div className='col-lg-3 col-sm-3 col-6'>
                                <div className='actions'>
                                  <div className="row">
                                    <div className='col-12 mb-2'><button disabled={!selectedProductName || !selectedCountry || !selectedGrade || !selectedOriginCountry || !minOfferQuantityMT || minOfferQuantityMT <= 0}onClick={handleGenerateOffer}>Generate Offer</button></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>                          
                      </div>
                    </div>
                  )}

                </section>
              </div>
              )}
              {selectedOption === 'entities' && (
                <div>
                    {activeOffersTab === "goAutomatic" && (
                      <div className="tab-content active">
                        <div className="row">
                          <div>
                            <section className="buyer-details">
                              <div className="tab-content active">
                                <div className="row">
                                  <div className="col-lg-9 col-sm-9 col-6">
                                    <div className="row">
                                      <div className="col-lg-3 col-sm-4 col-6">
                                        <label htmlFor="product">Product</label>
                                        <select
                                          className="form-control form-select"
                                          id="product"
                                          value={selectedProductName || ""}
                                          onChange={handleProductChange}
                                        >
                                          <option value="">
                                            Select a product
                                          </option>
                                          {[
                                            ...new Set(
                                              products.map(
                                                (product) => product.ProductName
                                              )
                                            ),
                                          ].map((product) => (
                                            <option
                                              key={product}
                                              value={product}
                                            >
                                              {product}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div className="col-lg-3 col-sm-4 col-6">
                                        <label htmlFor="grade">
                                          Product Grade
                                        </label>
                                        <select
                                          className="form-control form-select"
                                          id="grade"
                                          value={selectedGrade || ""}
                                          onChange={handleGradeChange}
                                        >
                                          <option value="">
                                            Select a Grade
                                          </option>
                                          {products
                                            .filter(
                                              (product) =>
                                                product.ProductName ===
                                                selectedProductName
                                            )
                                            .map((product) => (
                                              <option
                                                key={product.Grade}
                                                value={product.Grade}
                                              >
                                                {product.Grade}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                      <div className="col-lg-3 col-sm-4 col-6">
                                        <label htmlFor="grade">
                                          Destination Countries
                                        </label>
                                        <select
                                          className="form-control form-select"
                                          id="grade"
                                          value={selectedCountry || ""}
                                          onChange={handleCountryChange}
                                        >
                                          <option value="">
                                            Select a Country
                                          </option>
                                          {countries.map((country) => (
                                            <option
                                              key={country.Value}
                                              value={country.Value}
                                            >
                                              {country.Value}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div className="col-lg-3 col-sm-4 col-6">
                                        <label htmlFor="grade">
                                          Origin Country
                                        </label>
                                        <input
                                          type="text"
                                          readOnly
                                          value={selectedOriginCountry}
                                          className="form-control"
                                        />
                                      </div>
                                      <div className="col-lg-3 col-sm-4 col-6">
                                        <label htmlFor="grade">
                                          Global Partner
                                        </label>
                                        <select
                                          className="form-control form-select"
                                          id="globalPartner"
                                          name="globalPartner"
                                          value={selectedGlobalPartner || ""}
                                          onChange={handleGlobalPartnerChange}
                                        >
                                          <option value="">
                                            Select Global Partner
                                          </option>
                                          {[...new Set(globalPartners)].map(
                                            (partner) => {
                                              const match =
                                                partner.match(/<([^>]+)>/); // Regex to extract content within <>
                                              const keyAndValue = match
                                                ? match[1]
                                                : ""; // Extract content if present
                                              return (
                                                <option
                                                  key={keyAndValue}
                                                  value={keyAndValue}
                                                >
                                                  {partner}
                                                </option>
                                              );
                                            }
                                          )}
                                        </select>
                                      </div>
                                      <div className="col-lg-3 col-sm-4 col-6">
                                        <label htmlFor="grade">Buyer</label>
                                        <select
                                          className="form-control form-select"
                                          id="buyer"
                                          name="buyer"
                                          value={selectedBuyer || ""}
                                          onChange={handleBuyerChange}
                                        >
                                          <option value="">Select Buyer</option>
                                          {[...new Set(buyers)].map((buyer) => {
                                            const match =
                                              buyer.match(/<([^>]+)>/); // Regex to extract content within <>
                                            const keyAndValue = match
                                              ? match[1]
                                              : ""; // Extract content if present
                                            return (
                                              <option
                                                key={keyAndValue}
                                                value={keyAndValue}
                                              >
                                                {buyer}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      </div>

                                      <div className="col-lg-3 col-sm-4 col-6">
                                        <label>Min Offer Quantity (MT)</label>
                                        <input
                                          type="text"
                                          value={minOfferQuantityMT}
                                          className="form-control"
                                          onChange={
                                            handleMinOfferQuantityMTChange
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-3 col-sm-3 col-6">
                                    <div className="actions">
                                      <div className="row">
                                        <div className="col-12 mb-2">
                                          <button
                                            disabled={
                                              !selectedProductName ||
                                              !selectedCountry ||
                                              !selectedGrade ||
                                              !selectedOriginCountry ||
                                              !minOfferQuantityMT ||
                                              minOfferQuantityMT <= 0
                                            }
                                            onClick={handleGenerateOffer}
                                          >
                                            Generate Offer
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              )}
              {selectedOption === "entities" && (
                <div>
                  <section className="product-details">
                    <div className="tabs">
                      <button
                        className={
                          activeEntitiesTab === "buyer" ? "active" : ""
                        }
                        onClick={() => handleEntitiesTabClick("buyer")}
                      >
                        Buyer
                      </button>
                      <button
                        className={
                          activeEntitiesTab === "globalpartner" ? "active" : ""
                        }
                        onClick={() => handleEntitiesTabClick("globalpartner")}
                      >
                        Global Partner
                      </button>
                      <button
                        className={
                          activeEntitiesTab === "seller" ? "active" : ""
                        }
                        onClick={() => handleEntitiesTabClick("seller")}
                      >
                        Seller
                      </button>
                    </div>

                    {activeEntitiesTab === "buyer" && (
                      <div className="tab-content active">
                        <div className="row mb-3">
                          <div className="col-6">
                            <select
                              className="form-control form-select d-inline w-auto"
                              id="globalPartner"
                              name="globalPartner"
                              value={entitiesFilterTerms.globalPartner || ""}
                              onChange={handleEntitiesFilterChange}
                            >
                              <option value="">Select Global Partner</option>
                              {[...new Set(globalPartners)].map((partner) => {
                                const match = partner.match(/<([^>]+)>/); // Regex to extract content within <>
                                const keyAndValue = match ? match[1] : ""; // Extract content if present
                                return (
                                  <option key={keyAndValue} value={keyAndValue}>
                                    {partner}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-lg-3 col-sm-4 col-6">
                            <div className="offers-search row">
                              <div className="col-12">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    type="file"
                                    id="fileInput"
                                    accept=".xlsx"
                                    onChange={handleFileChange}
                                  />
                                  <button
                                    onClick={handleUpload}
                                    className="file-select btn btn-primary"
                                    disabled={!file}
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-3 align-items-center">
                          <div className="col-12 col-lg-10">
                            <div className="row g-2">
                              <div className="col-12 col-md-6 col-lg-3">
                                <select
                                  className="form-select"
                                  id="name"
                                  name="email"
                                  value={entitiesFilterTerms.email || ""}
                                  onChange={handleEntitiesFilterChange}
                                >
                                  <option value="">Select Name</option>
                                  {[...new Set(names)].map((name) => {
                                    const match = name.match(/<([^>]+)>/);
                                    const keyAndValue = match
                                      ? match[1].trim()
                                      : "";
                                    return (
                                      <option
                                        key={keyAndValue}
                                        value={keyAndValue}
                                      >
                                        {name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                              <div className="col-12 col-md-6 col-lg-3">
                                <select
                                  className="form-select"
                                  id="company"
                                  name="company"
                                  value={entitiesFilterTerms.company || ""}
                                  onChange={handleEntitiesFilterChange}
                                >
                                  <option value="">Select Company</option>
                                  {[...new Set(companies)].map((company) => (
                                    <option key={company} value={company}>
                                      {company}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-12 col-md-6 col-lg-3">
                                <select
                                  className="form-select"
                                  id="location"
                                  name="location"
                                  value={entitiesFilterTerms.location || ""}
                                  onChange={handleEntitiesFilterChange}
                                >
                                  <option value="">Select Location</option>
                                  {[...new Set(locations)].map((location) => (
                                    <option key={location} value={location}>
                                      {location}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-12 col-md-6 col-lg-3">
                                <select
                                  className="form-select"
                                  id="zipcode"
                                  name="zipcode"
                                  value={entitiesFilterTerms.zipcode || ""}
                                  onChange={handleEntitiesFilterChange}
                                >
                                  <option value="">Select Zipcode</option>
                                  {[...new Set(zipcodes)].map((zipcode) => (
                                    <option key={zipcode} value={zipcode}>
                                      {zipcode}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-lg-2 d-flex justify-content-lg-end mt-2 mt-lg-0">
                            <button
                              onClick={handleEntitiesSearch}
                              className="btn btn-primary me-2"
                            >
                              Search
                            </button>
                            <button
                              onClick={handleEntitiesReset}
                              className="btn btn-primary"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                        <div className="row">
                          <section className="offers">
                            <table>
                              <thead>
                                <tr>
                                  <th>Client Id</th>
                                  <th>Client Name</th>
                                  <th>Company</th>
                                  <th>Country</th>
                                  <th>State</th>
                                  <th>Phone</th>
                                  <th>Email</th>
                                </tr>
                              </thead>
                              <tbody>
                                {amtplBuyers.map((amtplUser) => (
                                  <tr
                                    key={amtplUser.AMTPLUserID}
                                    onClick={() =>
                                      handleAMTPLBuyerRowClick(amtplUser)
                                    }
                                    className={
                                      selectedAMTPLBuyer &&
                                      selectedAMTPLBuyer?.AMTPLUserID ===
                                        amtplUser.AMTPLUserID
                                        ? "selected"
                                        : ""
                                    }
                                  >
                                    <td>{amtplUser.AMTPLUserID}</td>
                                    <td>
                                      {amtplUser.FirstName} {amtplUser.LastName}
                                    </td>
                                    <td>{amtplUser.CompanyName}</td>
                                    <td>{amtplUser.Country}</td>
                                    <td>{amtplUser.State}</td>
                                    <td>{amtplUser.Phone1}</td>
                                    <td>{amtplUser.EmailID}</td>
                                  </tr>
                                ))}
                                {amtplBuyers.length === 0 && (
                                  <tr>
                                    <td colSpan="7">No Buyers available</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            <div className="pagination">
                              <button
                                onClick={() =>
                                  handleAMTPLBuyerPageChange(
                                    currentAMTPLBuyerPage - 1
                                  )
                                }
                                disabled={currentAMTPLBuyerPage === 1}
                              >
                                {"<"}
                              </button>
                              {Array.from(
                                { length: totalAMTPLBuyerPages },
                                (_, index) => (
                                  <button
                                    key={index + 1}
                                    onClick={() =>
                                      handleAMTPLBuyerPageChange(index + 1)
                                    }
                                    className={
                                      currentAMTPLBuyerPage === index + 1
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    {index + 1}
                                  </button>
                                )
                              )}
                              <button
                                onClick={() =>
                                  handleAMTPLBuyerPageChange(
                                    currentAMTPLBuyerPage + 1
                                  )
                                }
                                disabled={
                                  currentAMTPLBuyerPage === totalAMTPLBuyerPages
                                }
                              >
                                {">"}
                              </button>
                            </div>
                          </section>
                          <div>
                            <section className="buyer-details">
                              <div className="tabs">
                                <button
                                  className={
                                    activeEntitiesBuyerTab === "clientDetails"
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() =>
                                    handleEntitiesBuyerTabClick("clientDetails")
                                  }
                                >
                                  Client Details
                                </button>
                                <button
                                  className={
                                    activeEntitiesBuyerTab === "companyDetails"
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() =>
                                    handleEntitiesBuyerTabClick(
                                      "companyDetails"
                                    )
                                  }
                                >
                                  Company Details
                                </button>
                              </div>

                              {activeEntitiesBuyerTab === "clientDetails" &&
                                selectedAMTPLBuyer && (
                                  <div className="tab-content active">
                                    <div className="row">
                                      <div className="col-lg-9 col-sm-9 col-6">
                                        <div className="row">
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="firstName">
                                              First Name
                                            </label>
                                            <input
                                              id="FirstName"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.FirstName ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="lastName">
                                              Last Name
                                            </label>
                                            <input
                                              id="LastName"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.LastName ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="age">Age</label>
                                            <input
                                              id="Age"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.Age || ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="gender">
                                              Gender
                                            </label>
                                            <input
                                              id="Gender"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.Gender || ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="phone1">
                                              Phone 1
                                            </label>
                                            <input
                                              id="Phone1"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.Phone1 || ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="phone2">
                                              Phone 2
                                            </label>
                                            <input
                                              id="Phone2"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.Phone2 || ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="email">Email</label>
                                            <input
                                              id="EmailID"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.EmailID ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>

                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="linkedIn">
                                              LinkedIn
                                            </label>
                                            <input
                                              id="LinkedIn"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.LinkedIn ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="twitter">
                                              Twitter
                                            </label>
                                            <input
                                              id="Twitter"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.Twitter ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="website">
                                              Website
                                            </label>
                                            <input
                                              id="Website"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.Website ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="country">
                                              Country
                                            </label>
                                            <input
                                              id="Country"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.Country ||
                                                ""
                                              }
                                              readOnly
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="state">State</label>
                                            <input
                                              id="State"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.State || ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="address">
                                              Address
                                            </label>
                                            <input
                                              id="Address1"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.Address1 ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="pinZip">
                                              PIN/ ZIP
                                            </label>
                                            <input
                                              id="ZipCode"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.ZipCode ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-3 col-sm-3 col-6">
                                        <div className="actions">
                                          <div className="row">
                                            <div className="col-12 mb-2">
                                              <button
                                                disabled={!selectedAMTPLBuyer}
                                                onClick={handleBuyerSave}
                                              >
                                                Save
                                              </button>
                                            </div>
                                            <div className="col-12 mb-2">
                                              <button
                                                disabled={!selectedAMTPLBuyer}
                                                onClick={
                                                  handleBuyerResetPassword
                                                }
                                              >
                                                Generate & Send Password
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                              {activeEntitiesBuyerTab === "companyDetails" &&
                                selectedAMTPLBuyer && (
                                  <div className="tab-content active">
                                    <div className="row">
                                      <div className="col-lg-9 col-sm-9 col-6">
                                        <div className="row">
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="companyName">
                                              Co Name
                                            </label>
                                            <input
                                              id="CompanyName"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyName ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="website">
                                              Website
                                            </label>
                                            <input
                                              id="CompanyWebsite"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyWebsite ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="email">Email</label>
                                            <input
                                              id="CompanyEmail"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyEmail ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="country">
                                              Country
                                            </label>
                                            <input
                                              id="CompanyCountry"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyCountry ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="state">State</label>
                                            <input
                                              id="CompanyState"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyState ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="address">
                                              Address
                                            </label>
                                            <input
                                              id="CompanyAddress1"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyAddress1 ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="pinZip">
                                              PIN/ ZIP
                                            </label>
                                            <input
                                              id="CompanyZipCode"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyZipCode ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>

                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="linkedIn">
                                              LinkedIn
                                            </label>
                                            <input
                                              id="CompanyLinkedIn"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyLinkedIn ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="twitter">
                                              Twitter
                                            </label>
                                            <input
                                              id="CompanyTwitter"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyTwitter ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="website2">
                                              Website
                                            </label>
                                            <input
                                              id="CompanyWebsite"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyWebsite ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="phone1">
                                              Phone 1
                                            </label>
                                            <input
                                              id="CompanyPhone1"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyPhone1 ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="phone2">
                                              Phone 2
                                            </label>
                                            <input
                                              id="CompanyPhone2"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyPhone2 ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="phone3">
                                              Phone 3
                                            </label>
                                            <input
                                              id="CompanyPhone3"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyPhone3 ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                          <div className="col-lg-3 col-sm-4 col-6">
                                            <label htmlFor="phone4">
                                              Phone 4
                                            </label>
                                            <input
                                              id="CompanyPhone4"
                                              type="text"
                                              className="form-control"
                                              value={
                                                selectedAMTPLBuyer?.CompanyPhone4 ||
                                                ""
                                              }
                                              onChange={handleAMTPLBuyerChange}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-3 col-sm-3 col-6">
                                        <div className="actions">
                                          <div className="row">
                                            <div className="col-12 mb-2">
                                              <button
                                                disabled={!selectedAMTPLBuyer}
                                                onClick={handleBuyerSave}
                                              >
                                                Save
                                              </button>
                                            </div>
                                            <div className="col-12 mb-2">
                                              <button
                                                disabled={!selectedAMTPLBuyer}
                                                onClick={
                                                  handleBuyerResetPassword
                                                }
                                              >
                                                Generate & Send Password
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </section>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeEntitiesTab === "globalpartner" && (
                      <div className="tab-content active">
                        <div className="row mb-3">
                          <div className="col-lg-3 col-sm-4 col-6">
                            <div className="offers-search row">
                              <div className="col-12">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    type="file"
                                    id="fileInput"
                                    onChange={handleFileChange}
                                  />
                                  <button
                                    onClick={handleUpload}
                                    className="file-select btn btn-primary"
                                    disabled={!file}
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row mb-3 align-items-center">
                          <div className="col-12 col-lg-10">
                            <div className="d-flex flex-nowrap gap-2">
                              <select
                                className="form-select"
                                id="name"
                                name="email"
                                value={entitiesFilterTerms.email || ""}
                                onChange={handleEntitiesFilterChange}
                              >
                                <option value="">Select Name</option>
                                {[...new Set(names)].map((name) => {
                                  const match = name.match(/<([^>]+)>/);
                                  const keyAndValue = match
                                    ? match[1].trim()
                                    : "";
                                  return (
                                    <option
                                      key={keyAndValue}
                                      value={keyAndValue}
                                    >
                                      {name}
                                    </option>
                                  );
                                })}
                              </select>
                              <select
                                className="form-select"
                                id="company"
                                name="company"
                                value={entitiesFilterTerms.company || ""}
                                onChange={handleEntitiesFilterChange}
                              >
                                <option value="">Select Company</option>
                                {[...new Set(companies)].map((company) => (
                                  <option key={company} value={company}>
                                    {company}
                                  </option>
                                ))}
                              </select>
                              <select
                                className="form-select"
                                id="location"
                                name="location"
                                value={entitiesFilterTerms.location || ""}
                                onChange={handleEntitiesFilterChange}
                              >
                                <option value="">Select Location</option>
                                {[...new Set(locations)].map((location) => (
                                  <option key={location} value={location}>
                                    {location}
                                  </option>
                                ))}
                              </select>
                              <select
                                className="form-select"
                                id="zipcode"
                                name="zipcode"
                                value={entitiesFilterTerms.zipcode || ""}
                                onChange={handleEntitiesFilterChange}
                              >
                                <option value="">Select Zipcode</option>
                                {[...new Set(zipcodes)].map((zipcode) => (
                                  <option key={zipcode} value={zipcode}>
                                    {zipcode}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-12 col-lg-2 d-flex justify-content-lg-end mt-2 mt-lg-0">
                            <button
                              onClick={handleEntitiesSearch}
                              className="btn btn-primary me-2"
                            >
                              Search
                            </button>
                            <button
                              onClick={handleEntitiesReset}
                              className="btn btn-primary me-2"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                        <div className="row">
                          <section className="offers">
                            <table>
                              <thead>
                                <tr>
                                  <th>Partner Id</th>
                                  <th>Partner Name</th>
                                  <th>Company</th>
                                  <th>Country</th>
                                  <th>State</th>
                                  <th>Phone</th>
                                  <th>Email</th>
                                </tr>
                              </thead>
                              <tbody>
                                {amtplGlobalPartners.map((amtplUser) => (
                                  <tr
                                    key={amtplUser.AMTPLUserID}
                                    onClick={() =>
                                      handleAMTPLGlobalPartnerRowClick(
                                        amtplUser
                                      )
                                    }
                                    className={
                                      selectedAMTPLGlobalPartner &&
                                      selectedAMTPLGlobalPartner?.AMTPLUserID ===
                                        amtplUser.AMTPLUserID
                                        ? "selected"
                                        : ""
                                    }
                                  >
                                    <td>{amtplUser.AMTPLUserID}</td>
                                    <td>
                                      {amtplUser.FirstName} {amtplUser.LastName}
                                    </td>
                                    <td>{amtplUser.CompanyName}</td>
                                    <td>{amtplUser.Country}</td>
                                    <td>{amtplUser.State}</td>
                                    <td>{amtplUser.Phone1}</td>
                                    <td>{amtplUser.EmailID}</td>
                                  </tr>
                                ))}
                                {amtplGlobalPartners.length === 0 && (
                                  <tr>
                                    <td colSpan="7">
                                      No Global Partners available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            <div className="pagination">
                              <button
                                onClick={() =>
                                  handleAMTPLGlobalPartnerPageChange(
                                    currentAMTPLGlobalPartnerPage - 1
                                  )
                                }
                                disabled={currentAMTPLGlobalPartnerPage === 1}
                              >
                                {"<"}
                              </button>
                              {Array.from(
                                { length: totalAMTPLGlobalPartnerPages },
                                (_, index) => (
                                  <button
                                    key={index + 1}
                                    onClick={() =>
                                      handleAMTPLGlobalPartnerPageChange(
                                        index + 1
                                      )
                                    }
                                    className={
                                      currentAMTPLGlobalPartnerPage ===
                                      index + 1
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    {index + 1}
                                  </button>
                                )
                              )}
                              <button
                                onClick={() =>
                                  handleAMTPLGlobalPartnerPageChange(
                                    currentAMTPLGlobalPartnerPage + 1
                                  )
                                }
                                disabled={
                                  currentAMTPLGlobalPartnerPage ===
                                  totalAMTPLGlobalPartnerPages
                                }
                              >
                                {">"}
                              </button>
                            </div>
                          </section>
                          <section className="product-details">
                            <div className="tabs">
                              <button
                                className={
                                  activeEntitiesGlobalPartnerTab === "gpDetails"
                                    ? "active"
                                    : ""
                                }
                                onClick={() =>
                                  handleEntitiesGlobalPartnerTabClick(
                                    "gpDetails"
                                  )
                                }
                              >
                                Partner Details
                              </button>
                              <button
                                className={
                                  activeEntitiesGlobalPartnerTab ===
                                  "companyDetails"
                                    ? "active"
                                    : ""
                                }
                                onClick={() =>
                                  handleEntitiesGlobalPartnerTabClick(
                                    "companyDetails"
                                  )
                                }
                              >
                                Company Partner
                              </button>
                            </div>

                            {activeEntitiesGlobalPartnerTab === "gpDetails" &&
                              selectedAMTPLGlobalPartner && (
                                <div className="tab-content active">
                                  <div className="row">
                                    <div className="col-lg-9 col-sm-9 col-6">
                                      <div className="row">
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="firstName">
                                            First Name
                                          </label>
                                          <input
                                            id="FirstName"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.FirstName ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="lastName">
                                            Last Name
                                          </label>
                                          <input
                                            id="LastName"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.LastName ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="age">Age</label>
                                          <input
                                            id="Age"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.Age ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="gender">Gender</label>
                                          <input
                                            id="Gender"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.Gender ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone1">
                                            Phone 1
                                          </label>
                                          <input
                                            id="Phone1"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.Phone1 ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone2">
                                            Phone 2
                                          </label>
                                          <input
                                            id="Phone2"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.Phone2 ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="email">Email</label>
                                          <input
                                            id="EmailID"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.EmailID ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>

                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="linkedIn">
                                            LinkedIn
                                          </label>
                                          <input
                                            id="LinkedIn"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.LinkedIn ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="twitter">
                                            Twitter
                                          </label>
                                          <input
                                            id="Twitter"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.Twitter ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="website">
                                            Website
                                          </label>
                                          <input
                                            id="Website"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.Website ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="country">
                                            Country
                                          </label>
                                          <input
                                            id="Country"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.Country ||
                                              ""
                                            }
                                            readOnly
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="state">State</label>
                                          <input
                                            id="State"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.State ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="address">
                                            Address
                                          </label>
                                          <input
                                            id="Address1"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.Address1 ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="pinZip">
                                            PIN/ ZIP
                                          </label>
                                          <input
                                            id="ZipCode"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.ZipCode ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-3 col-6">
                                      <div className="actions">
                                        <div className="row">
                                          <div className="col-12 mb-2">
                                            <button
                                              disabled={
                                                !selectedAMTPLGlobalPartner
                                              }
                                              onClick={handleGlobalPartnerSave}
                                            >
                                              Save
                                            </button>
                                          </div>
                                          <div className="col-12 mb-2">
                                            <button
                                              disabled={
                                                !selectedAMTPLGlobalPartner
                                              }
                                              onClick={
                                                handleGlobalPartnerResetPassword
                                              }
                                            >
                                              Generate & Send Password
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                            {activeEntitiesGlobalPartnerTab ===
                              "companyDetails" &&
                              selectedAMTPLGlobalPartner && (
                                <div className="tab-content active">
                                  <div className="row">
                                    <div className="col-lg-9 col-sm-9 col-6">
                                      <div className="row">
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="companyName">
                                            Co Name
                                          </label>
                                          <input
                                            id="CompanyName"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyName ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="website">
                                            Website
                                          </label>
                                          <input
                                            id="CompanyWebsite"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyWebsite ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="email">Email</label>
                                          <input
                                            id="CompanyEmail"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyEmail ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="country">
                                            Country
                                          </label>
                                          <input
                                            id="CompanyCountry"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyCountry ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="state">State</label>
                                          <input
                                            id="CompanyState"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyState ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="address">
                                            Address
                                          </label>
                                          <input
                                            id="CompanyAddress1"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyAddress1 ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="pinZip">
                                            PIN/ ZIP
                                          </label>
                                          <input
                                            id="CompanyZipCode"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyZipCode ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>

                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="linkedIn">
                                            LinkedIn
                                          </label>
                                          <input
                                            id="CompanyLinkedIn"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyLinkedIn ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="twitter">
                                            Twitter
                                          </label>
                                          <input
                                            id="CompanyTwitter"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyTwitter ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="website2">
                                            Website
                                          </label>
                                          <input
                                            id="CompanyWebsite"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyWebsite ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone1">
                                            Phone 1
                                          </label>
                                          <input
                                            id="CompanyPhone1"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyPhone1 ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone2">
                                            Phone 2
                                          </label>
                                          <input
                                            id="CompanyPhone2"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyPhone2 ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone3">
                                            Phone 3
                                          </label>
                                          <input
                                            id="CompanyPhone3"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyPhone3 ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone4">
                                            Phone 4
                                          </label>
                                          <input
                                            id="CompanyPhone4"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLGlobalPartner?.CompanyPhone4 ||
                                              ""
                                            }
                                            onChange={
                                              handleAMTPLGlobalPartnerChange
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-3 col-6">
                                      <div className="actions">
                                        <div className="row">
                                          <div className="col-12 mb-2">
                                            <button
                                              disabled={
                                                !selectedAMTPLGlobalPartner
                                              }
                                              onClick={handleGlobalPartnerSave}
                                            >
                                              Save
                                            </button>
                                          </div>
                                          <div className="col-12 mb-2">
                                            <button
                                              disabled={
                                                !selectedAMTPLGlobalPartner
                                              }
                                              onClick={
                                                handleGlobalPartnerResetPassword
                                              }
                                            >
                                              Generate & Send Password
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </section>
                        </div>
                      </div>
                    )}

                    {activeEntitiesTab === "seller" && (
                      <div className="tab-content active">
                        <div className="row mb-3">
                          <div className="col-6">
                            <label className="d-inline mx-2" htmlFor="product">
                              Global Partner
                            </label>
                            <select
                              className="form-control form-select d-inline w-auto"
                              id="globalPartner"
                              value={selectedGlobalPartner || ""}
                              onChange={handleGlobalPartnerChange}
                            >
                              <option value="">Select Seller Type</option>
                              {[...new Set(sellerTypes)].map((sellerType) => (
                                <option key={sellerType} value={sellerType}>
                                  {sellerType}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-lg-3 col-sm-4 col-6">
                            <div className="offers-search row">
                              <div className="col-12">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    type="file"
                                    id="fileInput"
                                    onChange={handleFileChange}
                                  />
                                  <button
                                    onClick={handleUpload}
                                    className="file-select btn btn-primary"
                                    disabled={!file}
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-3 align-items-center">
                          <div className="col-12 col-lg-10">
                            <div className="d-flex flex-nowrap gap-2">
                              <select
                                className="form-select"
                                id="name"
                                name="email"
                                value={entitiesFilterTerms.email || ""}
                                onChange={handleEntitiesFilterChange}
                              >
                                <option value="">Select Name</option>
                                {[...new Set(names)].map((name) => {
                                  const match = name.match(/<([^>]+)>/);
                                  const keyAndValue = match
                                    ? match[1].trim()
                                    : "";
                                  return (
                                    <option
                                      key={keyAndValue}
                                      value={keyAndValue}
                                    >
                                      {name}
                                    </option>
                                  );
                                })}
                              </select>
                              <select
                                className="form-select"
                                id="company"
                                name="company"
                                value={entitiesFilterTerms.company || ""}
                                onChange={handleEntitiesFilterChange}
                              >
                                <option value="">Select Company</option>
                                {[...new Set(companies)].map((company) => (
                                  <option key={company} value={company}>
                                    {company}
                                  </option>
                                ))}
                              </select>
                              <select
                                className="form-select"
                                id="location"
                                name="location"
                                value={entitiesFilterTerms.location || ""}
                                onChange={handleEntitiesFilterChange}
                              >
                                <option value="">Select Location</option>
                                {[...new Set(locations)].map((location) => (
                                  <option key={location} value={location}>
                                    {location}
                                  </option>
                                ))}
                              </select>
                              <select
                                className="form-select"
                                id="zipcode"
                                name="zipcode"
                                value={entitiesFilterTerms.zipcode || ""}
                                onChange={handleEntitiesFilterChange}
                              >
                                <option value="">Select Zipcode</option>
                                {[...new Set(zipcodes)].map((zipcode) => (
                                  <option key={zipcode} value={zipcode}>
                                    {zipcode}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-12 col-lg-2 d-flex justify-content-lg-end mt-2 mt-lg-0">
                            <button
                              onClick={handleEntitiesSearch}
                              className="btn btn-primary me-2"
                            >
                              Search
                            </button>
                            <button
                              onClick={handleEntitiesReset}
                              className="btn btn-primary me-2"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                        <div className="row">
                          <section className="offers">
                            <table>
                              <thead>
                                <tr>
                                  <th>Supplier Id</th>
                                  <th>Supplier Name</th>
                                  <th>Company</th>
                                  <th>Country</th>
                                  <th>State</th>
                                  <th>Phone</th>
                                  <th>Email</th>
                                </tr>
                              </thead>
                              <tbody>
                                {amtplSellers.map((amtplUser) => (
                                  <tr
                                    key={amtplUser.AMTPLUserID}
                                    onClick={() =>
                                      handleAMTPLSellerRowClick(amtplUser)
                                    }
                                    className={
                                      selectedAMTPLSeller &&
                                      selectedAMTPLSeller?.AMTPLUserID ===
                                        amtplUser.AMTPLUserID
                                        ? "selected"
                                        : ""
                                    }
                                  >
                                    <td>{amtplUser.AMTPLUserID}</td>
                                    <td>
                                      {amtplUser.FirstName} {amtplUser.LastName}
                                    </td>
                                    <td>{amtplUser.CompanyName}</td>
                                    <td>{amtplUser.Country}</td>
                                    <td>{amtplUser.State}</td>
                                    <td>{amtplUser.Phone1}</td>
                                    <td>{amtplUser.EmailID}</td>
                                  </tr>
                                ))}
                                {amtplSellers.length === 0 && (
                                  <tr>
                                    <td colSpan="7">
                                      No matching users available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            <div className="pagination">
                              <button
                                onClick={() =>
                                  handleAMTPLSellerPageChange(
                                    currentAMTPLSellerPage - 1
                                  )
                                }
                                disabled={currentAMTPLSellerPage === 1}
                              >
                                {"<"}
                              </button>
                              {Array.from(
                                { length: totalAMTPLSellerPages },
                                (_, index) => (
                                  <button
                                    key={index + 1}
                                    onClick={() =>
                                      handleAMTPLSellerPageChange(index + 1)
                                    }
                                    className={
                                      currentAMTPLSellerPage === index + 1
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    {index + 1}
                                  </button>
                                )
                              )}
                              <button
                                onClick={() =>
                                  handleAMTPLSellerPageChange(
                                    currentAMTPLSellerPage + 1
                                  )
                                }
                                disabled={
                                  currentAMTPLSellerPage ===
                                  totalAMTPLSellerPages
                                }
                              >
                                {">"}
                              </button>
                            </div>
                          </section>
                          <section className="product-details">
                            <div className="tabs">
                              <button
                                className={
                                  activeEntitiesSellerTab === "supplierDetails"
                                    ? "active"
                                    : ""
                                }
                                onClick={() =>
                                  handleEntitiesSellerTabClick(
                                    "supplierDetails"
                                  )
                                }
                              >
                                Partner Details
                              </button>
                              <button
                                className={
                                  activeEntitiesSellerTab === "companyDetails"
                                    ? "active"
                                    : ""
                                }
                                onClick={() =>
                                  handleEntitiesSellerTabClick("companyDetails")
                                }
                              >
                                Company Partner
                              </button>
                            </div>

                            {activeEntitiesSellerTab === "supplierDetails" &&
                              selectedAMTPLSeller && (
                                <div className="tab-content active">
                                  <div className="row">
                                    <div className="col-lg-9 col-sm-9 col-6">
                                      <div className="row">
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="firstName">
                                            First Name
                                          </label>
                                          <input
                                            id="FirstName"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.FirstName ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="lastName">
                                            Last Name
                                          </label>
                                          <input
                                            id="LastName"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.LastName ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="age">Age</label>
                                          <input
                                            id="Age"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.Age || ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="gender">Gender</label>
                                          <input
                                            id="Gender"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.Gender || ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone1">
                                            Phone 1
                                          </label>
                                          <input
                                            id="Phone1"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.Phone1 || ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone2">
                                            Phone 2
                                          </label>
                                          <input
                                            id="Phone2"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.Phone2 || ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="email">Email</label>
                                          <input
                                            id="EmailID"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.EmailID || ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>

                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="linkedIn">
                                            LinkedIn
                                          </label>
                                          <input
                                            id="LinkedIn"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.LinkedIn ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="twitter">
                                            Twitter
                                          </label>
                                          <input
                                            id="Twitter"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.Twitter || ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="website">
                                            Website
                                          </label>
                                          <input
                                            id="Website"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.Website || ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="country">
                                            Country
                                          </label>
                                          <input
                                            id="Country"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.Country || ""
                                            }
                                            readOnly
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="state">State</label>
                                          <input
                                            id="State"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.State || ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="address">
                                            Address
                                          </label>
                                          <input
                                            id="Address1"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.Address1 ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="pinZip">
                                            PIN/ ZIP
                                          </label>
                                          <input
                                            id="ZipCode"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.ZipCode || ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-3 col-6">
                                      <div className="actions">
                                        <div className="row">
                                          <div className="col-12 mb-2">
                                            <button
                                              disabled={!selectedAMTPLSeller}
                                              onClick={handleSellerSave}
                                            >
                                              Save
                                            </button>
                                          </div>
                                          <div className="col-12 mb-2">
                                            <button
                                              disabled={!selectedAMTPLSeller}
                                              onClick={
                                                handleSellerResetPassword
                                              }
                                            >
                                              Generate & Send Password
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                            {activeEntitiesSellerTab === "companyDetails" &&
                              selectedAMTPLSeller && (
                                <div className="tab-content active">
                                  <div className="row">
                                    <div className="col-lg-9 col-sm-9 col-6">
                                      <div className="row">
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="companyName">
                                            Co Name
                                          </label>
                                          <input
                                            id="CompanyName"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyName ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="website">
                                            Website
                                          </label>
                                          <input
                                            id="CompanyWebsite"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyWebsite ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="email">Email</label>
                                          <input
                                            id="CompanyEmail"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyEmail ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="country">
                                            Country
                                          </label>
                                          <input
                                            id="CompanyCountry"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyCountry ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="state">State</label>
                                          <input
                                            id="CompanyState"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyState ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="address">
                                            Address
                                          </label>
                                          <input
                                            id="CompanyAddress1"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyAddress1 ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="pinZip">
                                            PIN/ ZIP
                                          </label>
                                          <input
                                            id="CompanyZipCode"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyZipCode ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>

                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="linkedIn">
                                            LinkedIn
                                          </label>
                                          <input
                                            id="CompanyLinkedIn"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyLinkedIn ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="twitter">
                                            Twitter
                                          </label>
                                          <input
                                            id="CompanyTwitter"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyTwitter ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="website2">
                                            Website
                                          </label>
                                          <input
                                            id="CompanyWebsite"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyWebsite ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone1">
                                            Phone 1
                                          </label>
                                          <input
                                            id="CompanyPhone1"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyPhone1 ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone2">
                                            Phone 2
                                          </label>
                                          <input
                                            id="CompanyPhone2"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyPhone2 ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone3">
                                            Phone 3
                                          </label>
                                          <input
                                            id="CompanyPhone3"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyPhone3 ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                        <div className="col-lg-3 col-sm-4 col-6">
                                          <label htmlFor="phone4">
                                            Phone 4
                                          </label>
                                          <input
                                            id="CompanyPhone4"
                                            type="text"
                                            className="form-control"
                                            value={
                                              selectedAMTPLSeller?.CompanyPhone4 ||
                                              ""
                                            }
                                            onChange={handleAMTPLSellerChange}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-3 col-6">
                                      <div className="actions">
                                        <div className="row">
                                          <div className="col-12 mb-2">
                                            <button
                                              disabled={!selectedAMTPLSeller}
                                              onClick={handleSellerSave}
                                            >
                                              Save
                                            </button>
                                          </div>
                                          <div className="col-12 mb-2">
                                            <button
                                              disabled={!selectedAMTPLSeller}
                                              onClick={
                                                handleSellerResetPassword
                                              }
                                            >
                                              Generate & Send Password
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </section>
                        </div>
                      </div>
                    )}
                  </section>
                </div>
              )}
            </div>
          </div>
        </main>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>{showModalMsg}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showRaiseQueryModal}
          onHide={() => setShowRaiseQueryModal(false)}
          backdrop="static"
          className="modal-raisequery"
        >
          <Modal.Header closeButton>
            <Modal.Title>Raise Query</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-3">
              {/* Query Date */}
              <div className="offers-search row">
                <div className="col-lg-3 col-sm-4 col-6">
                  <label className="form-label">Query Date</label>
                </div>
                <div className="col-lg-3 col-sm-4 col-6">
                  <input
                    type="text"
                    className="form-control"
                    value={selectedQuery?.QueryDate || ""}
                    readOnly
                  />
                </div>
              </div>
              {/* Query Description in Multi-line */}
              <div className="col-12 mb-2">
                <label className="form-label">Query Description</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={selectedQuery?.QueryDescription || ""}
                  readOnly
                />
              </div>

              {/* Query Type */}
              <div className="offers-search row">
                <div className="col-lg-3 col-sm-4 col-6">
                  <label className="form-label">Query Type</label>
                </div>
                <div className="col-lg-3 col-sm-4 col-6">
                  <input
                    type="text"
                    className="form-control"
                    value={selectedQuery?.QueryType || ""}
                    readOnly
                  />
                </div>
              </div>

              {/* Conditional Email ID */}
              {selectedQuery?.GPEmailID && (
                <div className="offers-search row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label className="form-label">GP Email ID</label>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <input
                      type="text"
                      className="form-control"
                      value={selectedQuery?.GPEmailID || ""}
                      readOnly
                    />
                  </div>
                </div>
              )}
              {selectedQuery?.SellerEmailID && (
                <div className="offers-search row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label className="form-label">Seller Email ID</label>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <input
                      type="text"
                      className="form-control"
                      value={selectedQuery?.SellerEmailID || ""}
                      readOnly
                    />
                  </div>
                </div>
              )}
              {selectedQuery?.APEmailID && (
                <div className="offers-search row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label className="form-label">AP Email ID</label>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <input
                      type="text"
                      className="form-control"
                      value={selectedQuery?.APEmailID || ""}
                      readOnly
                    />
                  </div>
                </div>
              )}
              {selectedQuery?.BuyerEmailID && (
                <div className="offers-search row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label className="form-label">Buyer Email ID</label>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <input
                      type="text"
                      className="form-control"
                      value={selectedQuery?.BuyerEmailID || ""}
                      readOnly
                    />
                  </div>
                </div>
              )}

              {/* Conditional Item ID */}
              {selectedQuery?.GPOfferID && (
                <div className="offers-search row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label className="form-label">GPOffer ID</label>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <input
                      type="text"
                      className="form-control"
                      value={selectedQuery?.GPOfferID || ""}
                      readOnly
                    />
                  </div>
                </div>
              )}
              {selectedQuery?.SellerItemID && (
                <div className="offers-search row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label className="form-label">Seller Item ID</label>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <input
                      type="text"
                      className="form-control"
                      value={selectedQuery?.SellerItemID || ""}
                      readOnly
                    />
                  </div>
                </div>
              )}
              {selectedQuery?.APItemID && (
                <div className="offers-search row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label className="form-label">AP Item ID</label>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <input
                      type="text"
                      className="form-control"
                      value={selectedQuery?.APItemID || ""}
                      readOnly
                    />
                  </div>
                </div>
              )}
              {selectedQuery?.BuyerItemID && (
                <div className="offers-search row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label className="form-label">Buyer Item ID</label>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <input
                      type="text"
                      className="form-control"
                      value={selectedQuery?.BuyerItemID || ""}
                      readOnly
                    />
                  </div>
                </div>
              )}

              {/* Query Reply Section */}
              <div className="col-12 mb-2">
                <label className="form-label">Query Reply</label>
                <textarea
                  placeholder="Enter your reply"
                  className="form-control"
                  rows="4"
                  value={queryDescription}
                  onChange={(e) => setQueryDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleUpdateQuery}>
              Respond to Query
            </Button>
            <Button
              variant="secondary"
              onClick={() => setShowRaiseQueryModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default AMTPL;
